import { Loader2 } from 'lucide-react';
import type { SVGProps } from 'react';

import { cn } from '@/lib/utils';

export const BotIcon = () => {
  return (
    <svg
      height="16"
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width="16"
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.75 2.79933C9.19835 2.53997 9.5 2.05521 9.5 1.5C9.5 0.671573 8.82843 0 8 0C7.17157 0 6.5 0.671573 6.5 1.5C6.5 2.05521 6.80165 2.53997 7.25 2.79933V5H7C4.027 5 1.55904 7.16229 1.08296 10H0V13H1V14.5V16H2.5H13.5H15V14.5V13H16V10H14.917C14.441 7.16229 11.973 5 9 5H8.75V2.79933ZM7 6.5C4.51472 6.5 2.5 8.51472 2.5 11V14.5H13.5V11C13.5 8.51472 11.4853 6.5 9 6.5H7ZM7.25 11.25C7.25 12.2165 6.4665 13 5.5 13C4.5335 13 3.75 12.2165 3.75 11.25C3.75 10.2835 4.5335 9.5 5.5 9.5C6.4665 9.5 7.25 10.2835 7.25 11.25ZM10.5 13C11.4665 13 12.25 12.2165 12.25 11.25C12.25 10.2835 11.4665 9.5 10.5 9.5C9.5335 9.5 8.75 10.2835 8.75 11.25C8.75 12.2165 9.5335 13 10.5 13Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UserIcon = () => {
  return (
    <svg
      data-testid="geist-icon"
      height="16"
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width="16"
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.75 0C5.95507 0 4.5 1.45507 4.5 3.25V3.75C4.5 5.54493 5.95507 7 7.75 7H8.25C10.0449 7 11.5 5.54493 11.5 3.75V3.25C11.5 1.45507 10.0449 0 8.25 0H7.75ZM6 3.25C6 2.2835 6.7835 1.5 7.75 1.5H8.25C9.2165 1.5 10 2.2835 10 3.25V3.75C10 4.7165 9.2165 5.5 8.25 5.5H7.75C6.7835 5.5 6 4.7165 6 3.75V3.25ZM2.5 14.5V13.1709C3.31958 11.5377 4.99308 10.5 6.82945 10.5H9.17055C11.0069 10.5 12.6804 11.5377 13.5 13.1709V14.5H2.5ZM6.82945 9C4.35483 9 2.10604 10.4388 1.06903 12.6857L1 12.8353V13V15.25V16H1.75H14.25H15V15.25V13V12.8353L14.931 12.6857C13.894 10.4388 11.6452 9 9.17055 9H6.82945Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Logo = ({
  size = 16,
  color = 'white',
  className,
}: {
  size: number;
  color?: 'white' | 'black';
  className?: string;
}) => {
  const fill = color === 'white' ? '#FFFFFF' : '#000000';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect y="0" width="16" height="16" rx="2" fill={fill} />
    </svg>
  );
};

export const AttachmentIcon = () => {
  return (
    <svg
      height="16"
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width="16"
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 6.5V13.5C14.5 14.8807 13.3807 16 12 16H4C2.61929 16 1.5 14.8807 1.5 13.5V1.5V0H3H8H9.08579C9.351 0 9.60536 0.105357 9.79289 0.292893L14.2071 4.70711C14.3946 4.89464 14.5 5.149 14.5 5.41421V6.5ZM13 6.5V13.5C13 14.0523 12.5523 14.5 12 14.5H4C3.44772 14.5 3 14.0523 3 13.5V1.5H8V5V6.5H9.5H13ZM9.5 2.12132V5H12.3787L9.5 2.12132Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const VercelIcon = ({ size = 17 }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M8 1L16 15H0L8 1Z" fill="currentColor" />
    </svg>
  );
};

export const GitIcon = () => {
  return (
    <svg
      height="16"
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width="16"
      style={{ color: 'currentcolor' }}
    >
      <g clipPath="url(#clip0_872_3147)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 0C3.58 0 0 3.57879 0 7.99729C0 11.5361 2.29 14.5251 5.47 15.5847C5.87 15.6547 6.02 15.4148 6.02 15.2049C6.02 15.0149 6.01 14.3851 6.01 13.7154C4 14.0852 3.48 13.2255 3.32 12.7757C3.23 12.5458 2.84 11.836 2.5 11.6461C2.22 11.4961 1.82 11.1262 2.49 11.1162C3.12 11.1062 3.57 11.696 3.72 11.936C4.44 13.1455 5.59 12.8057 6.05 12.5957C6.12 12.0759 6.33 11.726 6.56 11.5261C4.78 11.3262 2.92 10.6364 2.92 7.57743C2.92 6.70773 3.23 5.98797 3.74 5.42816C3.66 5.22823 3.38 4.40851 3.82 3.30888C3.82 3.30888 4.49 3.09895 6.02 4.1286C6.66 3.94866 7.34 3.85869 8.02 3.85869C8.7 3.85869 9.38 3.94866 10.02 4.1286C11.55 3.08895 12.22 3.30888 12.22 3.30888C12.66 4.40851 12.38 5.22823 12.3 5.42816C12.81 5.98797 13.12 6.69773 13.12 7.57743C13.12 10.6464 11.25 11.3262 9.47 11.5261C9.76 11.776 10.01 12.2558 10.01 13.0056C10.01 14.0752 10 14.9349 10 15.2049C10 15.4148 10.15 15.6647 10.55 15.5847C12.1381 15.0488 13.5182 14.0284 14.4958 12.6673C15.4735 11.3062 15.9996 9.67293 16 7.99729C16 3.57879 12.42 0 8 0Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_872_3147">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GithubIcon = ({ className }: { className?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
      <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
    </svg>
  );
};

export const BoxIcon = ({ size = 16 }: { size: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0.154663L8.34601 0.334591L14.596 3.58459L15 3.79466V4.25V11.75V12.2053L14.596 12.4154L8.34601 15.6654L8 15.8453L7.65399 15.6654L1.40399 12.4154L1 12.2053V11.75V4.25V3.79466L1.40399 3.58459L7.65399 0.334591L8 0.154663ZM2.5 11.2947V5.44058L7.25 7.81559V13.7647L2.5 11.2947ZM8.75 13.7647L13.5 11.2947V5.44056L8.75 7.81556V13.7647ZM8 1.84534L12.5766 4.22519L7.99998 6.51352L3.42335 4.2252L8 1.84534Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const HomeIcon = ({ size = 16 }: { size: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 6.56062L8.00001 2.06062L3.50001 6.56062V13.5L6.00001 13.5V11C6.00001 9.89539 6.89544 8.99996 8.00001 8.99996C9.10458 8.99996 10 9.89539 10 11V13.5L12.5 13.5V6.56062ZM13.78 5.71933L8.70711 0.646409C8.31659 0.255886 7.68342 0.255883 7.2929 0.646409L2.21987 5.71944C2.21974 5.71957 2.21961 5.7197 2.21949 5.71982L0.469676 7.46963L-0.0606537 7.99996L1.00001 9.06062L1.53034 8.53029L2.00001 8.06062V14.25V15H2.75001L6.00001 15H7.50001H8.50001H10L13.25 15H14V14.25V8.06062L14.4697 8.53029L15 9.06062L16.0607 7.99996L15.5303 7.46963L13.7806 5.71993C13.7804 5.71973 13.7802 5.71953 13.78 5.71933ZM8.50001 11V13.5H7.50001V11C7.50001 10.7238 7.72386 10.5 8.00001 10.5C8.27615 10.5 8.50001 10.7238 8.50001 11Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const GPSIcon = ({ size = 16 }: { size: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        d="M1 6L15 1L10 15L7.65955 8.91482C7.55797 8.65073 7.34927 8.44203 7.08518 8.34045L1 6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="bevel"
        fill="transparent"
      />
    </svg>
  );
};

export const InvoiceIcon = ({ size = 16 }: { size: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 15.1L12 14.5L10.1524 15.8857C10.0621 15.9534 9.93791 15.9534 9.8476 15.8857L8 14.5L6.14377 15.8922C6.05761 15.9568 5.94008 15.9601 5.85047 15.9003L3.75 14.5L3 15L2.83257 15.1116L1.83633 15.7758L1.68656 15.8756C1.60682 15.9288 1.5 15.8716 1.5 15.7758V15.5958V14.3985V14.1972V1.5V0H3H8H9.08579C9.351 0 9.60536 0.105357 9.79289 0.292893L14.2071 4.70711C14.3946 4.89464 14.5 5.149 14.5 5.41421V6.5V14.2507V14.411V15.5881V15.7881C14.5 15.8813 14.3982 15.9389 14.3183 15.891L14.1468 15.7881L13.1375 15.1825L13 15.1ZM12.3787 5L9.5 2.12132V5H12.3787ZM8 1.5V5V6.5H9.5H13V13.3507L12.7717 13.2138L11.9069 12.6948L11.1 13.3L10 14.125L8.9 13.3L8 12.625L7.1 13.3L5.94902 14.1632L4.58205 13.2519L3.75 12.6972L3 13.1972V1.5H8Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const LogoOpenAI = ({ size = 16, className }: { size?: number; className?: string }) => {
  return (
    <svg
      aria-hidden="true"
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      className={className}
    >
      <path
        d="M14.9449 6.54871C15.3128 5.45919 15.1861 4.26567 14.5978 3.27464C13.7131 1.75461 11.9345 0.972595 10.1974 1.3406C9.42464 0.481584 8.3144 -0.00692594 7.15045 7.42132e-05C5.37487 -0.00392587 3.79946 1.1241 3.2532 2.79113C2.11256 3.02164 1.12799 3.72615 0.551837 4.72468C-0.339497 6.24071 -0.1363 8.15175 1.05451 9.45178C0.686626 10.5413 0.813308 11.7348 1.40162 12.7258C2.28637 14.2459 4.06498 15.0279 5.80204 14.6599C6.5743 15.5189 7.68504 16.0074 8.849 15.9999C10.6256 16.0044 12.2015 14.8754 12.7478 13.2069C13.8884 12.9764 14.873 12.2718 15.4491 11.2733C16.3394 9.75728 16.1357 7.84774 14.9454 6.54771L14.9449 6.54871ZM8.85001 14.9544C8.13907 14.9554 7.45043 14.7099 6.90468 14.2604C6.92951 14.2474 6.97259 14.2239 7.00046 14.2069L10.2293 12.3668C10.3945 12.2743 10.4959 12.1008 10.4949 11.9133V7.42173L11.8595 8.19925C11.8742 8.20625 11.8838 8.22025 11.8858 8.23625V11.9558C11.8838 13.6099 10.5263 14.9509 8.85001 14.9544ZM2.32133 12.2028C1.9651 11.5958 1.8369 10.8843 1.95902 10.1938C1.98284 10.2078 2.02489 10.2333 2.05479 10.2503L5.28366 12.0903C5.44733 12.1848 5.65003 12.1848 5.81421 12.0903L9.75604 9.84429V11.3993C9.75705 11.4153 9.74945 11.4308 9.73678 11.4408L6.47295 13.3004C5.01915 14.1264 3.1625 13.6354 2.32184 12.2028H2.32133ZM1.47155 5.24819C1.82626 4.64017 2.38619 4.17516 3.05305 3.93366C3.05305 3.96116 3.05152 4.00966 3.05152 4.04366V7.72424C3.05051 7.91124 3.15186 8.08475 3.31654 8.17725L7.25838 10.4228L5.89376 11.2003C5.88008 11.2093 5.86285 11.2108 5.84765 11.2043L2.58331 9.34327C1.13255 8.51426 0.63494 6.68272 1.47104 5.24869L1.47155 5.24819ZM12.6834 7.82274L8.74157 5.57669L10.1062 4.79968C10.1199 4.79068 10.1371 4.78918 10.1523 4.79568L13.4166 6.65522C14.8699 7.48373 15.3681 9.31827 14.5284 10.7523C14.1732 11.3593 13.6138 11.8243 12.9474 12.0663V8.27575C12.9489 8.08875 12.8481 7.91574 12.6839 7.82274H12.6834ZM14.0414 5.8057C14.0176 5.7912 13.9756 5.7662 13.9457 5.7492L10.7168 3.90916C10.5531 3.81466 10.3504 3.81466 10.1863 3.90916L6.24442 6.15521V4.60017C6.2434 4.58417 6.251 4.56867 6.26367 4.55867L9.52751 2.70063C10.9813 1.87311 12.84 2.36563 13.6781 3.80066C14.0323 4.40667 14.1605 5.11618 14.0404 5.8057H14.0414ZM5.50257 8.57726L4.13744 7.79974C4.12275 7.79274 4.11312 7.77874 4.11109 7.76274V4.04316C4.11211 2.38713 5.47368 1.0451 7.15197 1.0461C7.86189 1.0461 8.54902 1.2921 9.09476 1.74011C9.06993 1.75311 9.02737 1.77661 8.99899 1.79361L5.77012 3.63365C5.60493 3.72615 5.50358 3.89916 5.50459 4.08666L5.50257 8.57626V8.57726ZM6.24391 7.00022L7.99972 5.9997L9.75553 6.99972V9.00027L7.99972 10.0003L6.24391 9.00027V7.00022Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const LogoGoogle = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      data-testid="geist-icon"
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        d="M8.15991 6.54543V9.64362H12.4654C12.2763 10.64 11.709 11.4837 10.8581 12.0509L13.4544 14.0655C14.9671 12.6692 15.8399 10.6182 15.8399 8.18188C15.8399 7.61461 15.789 7.06911 15.6944 6.54552L8.15991 6.54543Z"
        fill="#4285F4"
      />
      <path
        d="M3.6764 9.52268L3.09083 9.97093L1.01807 11.5855C2.33443 14.1963 5.03241 16 8.15966 16C10.3196 16 12.1305 15.2873 13.4542 14.0655L10.8578 12.0509C10.1451 12.5309 9.23598 12.8219 8.15966 12.8219C6.07967 12.8219 4.31245 11.4182 3.67967 9.5273L3.6764 9.52268Z"
        fill="#34A853"
      />
      <path
        d="M1.01803 4.41455C0.472607 5.49087 0.159912 6.70543 0.159912 7.99995C0.159912 9.29447 0.472607 10.509 1.01803 11.5854C1.01803 11.5926 3.6799 9.51991 3.6799 9.51991C3.5199 9.03991 3.42532 8.53085 3.42532 7.99987C3.42532 7.46889 3.5199 6.95983 3.6799 6.47983L1.01803 4.41455Z"
        fill="#FBBC05"
      />
      <path
        d="M8.15982 3.18545C9.33802 3.18545 10.3853 3.59271 11.2216 4.37818L13.5125 2.0873C12.1234 0.792777 10.3199 0 8.15982 0C5.03257 0 2.33443 1.79636 1.01807 4.41455L3.67985 6.48001C4.31254 4.58908 6.07983 3.18545 8.15982 3.18545Z"
        fill="#EA4335"
      />
    </svg>
  );
};

export const LogoAnthropic = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 92.2 65"
      style={{ color: 'currentcolor', fill: 'currentcolor' }}
      width="18px"
      height="18px"
    >
      <path d="M66.5,0H52.4l25.7,65h14.1L66.5,0z M25.7,0L0,65h14.4l5.3-13.6h26.9L51.8,65h14.4L40.5,0C40.5,0,25.7,0,25.7,0z M24.3,39.3l8.8-22.8l8.8,22.8H24.3z" />
    </svg>
  );
};

export const RouteIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.53033 0.719661L7 0.189331L5.93934 1.24999L6.46967 1.78032L6.68934 1.99999H3.375C1.51104 1.99999 0 3.51103 0 5.37499C0 7.23895 1.51104 8.74999 3.375 8.74999H12.625C13.6605 8.74999 14.5 9.58946 14.5 10.625C14.5 11.6605 13.6605 12.5 12.625 12.5H4.88555C4.56698 11.4857 3.61941 10.75 2.5 10.75C1.11929 10.75 0 11.8693 0 13.25C0 14.6307 1.11929 15.75 2.5 15.75C3.61941 15.75 4.56698 15.0143 4.88555 14H12.625C14.489 14 16 12.489 16 10.625C16 8.76103 14.489 7.24999 12.625 7.24999H3.375C2.33947 7.24999 1.5 6.41052 1.5 5.37499C1.5 4.33946 2.33947 3.49999 3.375 3.49999H6.68934L6.46967 3.71966L5.93934 4.24999L7 5.31065L7.53033 4.78032L8.85355 3.4571C9.24408 3.06657 9.24408 2.43341 8.85355 2.04288L7.53033 0.719661ZM2.5 14.25C3.05228 14.25 3.5 13.8023 3.5 13.25C3.5 12.6977 3.05228 12.25 2.5 12.25C1.94772 12.25 1.5 12.6977 1.5 13.25C1.5 13.8023 1.94772 14.25 2.5 14.25ZM14.5 2.74999C14.5 3.30228 14.0523 3.74999 13.5 3.74999C12.9477 3.74999 12.5 3.30228 12.5 2.74999C12.5 2.19771 12.9477 1.74999 13.5 1.74999C14.0523 1.74999 14.5 2.19771 14.5 2.74999ZM16 2.74999C16 4.1307 14.8807 5.24999 13.5 5.24999C12.1193 5.24999 11 4.1307 11 2.74999C11 1.36928 12.1193 0.249991 13.5 0.249991C14.8807 0.249991 16 1.36928 16 2.74999Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const FileIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 13.5V6.5V5.41421C14.5 5.149 14.3946 4.89464 14.2071 4.70711L9.79289 0.292893C9.60536 0.105357 9.351 0 9.08579 0H8H3H1.5V1.5V13.5C1.5 14.8807 2.61929 16 4 16H12C13.3807 16 14.5 14.8807 14.5 13.5ZM13 13.5V6.5H9.5H8V5V1.5H3V13.5C3 14.0523 3.44772 14.5 4 14.5H12C12.5523 14.5 13 14.0523 13 13.5ZM9.5 5V2.12132L12.3787 5H9.5ZM5.13 5.00062H4.505V6.25062H5.13H6H6.625V5.00062H6H5.13ZM4.505 8H5.13H11H11.625V9.25H11H5.13H4.505V8ZM5.13 11H4.505V12.25H5.13H11H11.625V11H11H5.13Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const LoaderIcon = ({ size = 16, className }: { size?: number; className?: string }) => {
  return <Loader2 size={size} className={cn('animate-spin', className)} />;
};

export const UploadIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      data-testid="geist-icon"
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 4.875C1.5 3.01104 3.01104 1.5 4.875 1.5C6.20018 1.5 7.34838 2.26364 7.901 3.37829C8.1902 3.96162 8.79547 4.5 9.60112 4.5H12.25C13.4926 4.5 14.5 5.50736 14.5 6.75C14.5 7.42688 14.202 8.03329 13.7276 8.44689L13.1622 8.93972L14.1479 10.0704L14.7133 9.57758C15.5006 8.89123 16 7.8785 16 6.75C16 4.67893 14.3211 3 12.25 3H9.60112C9.51183 3 9.35322 2.93049 9.2449 2.71201C8.44888 1.1064 6.79184 0 4.875 0C2.18261 0 0 2.18261 0 4.875V6.40385C0 7.69502 0.598275 8.84699 1.52982 9.59656L2.11415 10.0667L3.0545 8.89808L2.47018 8.42791C1.87727 7.95083 1.5 7.22166 1.5 6.40385V4.875ZM7.29289 7.39645C7.68342 7.00592 8.31658 7.00592 8.70711 7.39645L11.7803 10.4697L12.3107 11L11.25 12.0607L10.7197 11.5303L8.75 9.56066V15.25V16H7.25V15.25V9.56066L5.28033 11.5303L4.75 12.0607L3.68934 11L4.21967 10.4697L7.29289 7.39645Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MenuIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2H1.75H14.25H15V3.5H14.25H1.75H1V2ZM1 12.5H1.75H14.25H15V14H14.25H1.75H1V12.5ZM1.75 7.25H1V8.75H1.75H14.25H15V7.25H14.25H1.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PencilEditIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.75 0.189331L12.2803 0.719661L15.2803 3.71966L15.8107 4.24999L15.2803 4.78032L5.15901 14.9016C4.45575 15.6049 3.50192 16 2.50736 16H0.75H0V15.25V13.4926C0 12.4981 0.395088 11.5442 1.09835 10.841L11.2197 0.719661L11.75 0.189331ZM11.75 2.31065L9.81066 4.24999L11.75 6.18933L13.6893 4.24999L11.75 2.31065ZM2.15901 11.9016L8.75 5.31065L10.6893 7.24999L4.09835 13.841C3.67639 14.2629 3.1041 14.5 2.50736 14.5H1.5V13.4926C1.5 12.8959 1.73705 12.3236 2.15901 11.9016ZM9 16H16V14.5H9V16Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CheckedSquare = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 16H1C0.447715 16 0 15.5523 0 15V1C0 0.447715 0.447716 0 1 0L15 8.17435e-06C15.5523 8.47532e-06 16 0.447724 16 1.00001V15C16 15.5523 15.5523 16 15 16ZM11.7803 6.28033L12.3107 5.75L11.25 4.68934L10.7197 5.21967L6.5 9.43935L5.28033 8.21967L4.75001 7.68934L3.68934 8.74999L4.21967 9.28033L5.96967 11.0303C6.11032 11.171 6.30109 11.25 6.5 11.25C6.69891 11.25 6.88968 11.171 7.03033 11.0303L11.7803 6.28033Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UncheckedSquare = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <rect
        x="1"
        y="1"
        width="14"
        height="14"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  );
};

export const MoreIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 4C7.17157 4 6.5 3.32843 6.5 2.5C6.5 1.67157 7.17157 1 8 1C8.82843 1 9.5 1.67157 9.5 2.5C9.5 3.32843 8.82843 4 8 4ZM8 9.5C7.17157 9.5 6.5 8.82843 6.5 8C6.5 7.17157 7.17157 6.5 8 6.5C8.82843 6.5 9.5 7.17157 9.5 8C9.5 8.82843 8.82843 9.5 8 9.5ZM6.5 13.5C6.5 14.3284 7.17157 15 8 15C8.82843 15 9.5 14.3284 9.5 13.5C9.5 12.6716 8.82843 12 8 12C7.17157 12 6.5 12.6716 6.5 13.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TrashIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 2.75C6.75 2.05964 7.30964 1.5 8 1.5C8.69036 1.5 9.25 2.05964 9.25 2.75V3H6.75V2.75ZM5.25 3V2.75C5.25 1.23122 6.48122 0 8 0C9.51878 0 10.75 1.23122 10.75 2.75V3H12.9201H14.25H15V4.5H14.25H13.8846L13.1776 13.6917C13.0774 14.9942 11.9913 16 10.6849 16H5.31508C4.00874 16 2.92263 14.9942 2.82244 13.6917L2.11538 4.5H1.75H1V3H1.75H3.07988H5.25ZM4.31802 13.5767L3.61982 4.5H12.3802L11.682 13.5767C11.6419 14.0977 11.2075 14.5 10.6849 14.5H5.31508C4.79254 14.5 4.3581 14.0977 4.31802 13.5767Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const InfoIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM6.25002 7H7.00002H7.75C8.30229 7 8.75 7.44772 8.75 8V11.5V12.25H7.25V11.5V8.5H7.00002H6.25002V7ZM8 6C8.55229 6 9 5.55228 9 5C9 4.44772 8.55229 4 8 4C7.44772 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ArrowUpIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.70711 1.39644C8.31659 1.00592 7.68342 1.00592 7.2929 1.39644L2.21968 6.46966L1.68935 6.99999L2.75001 8.06065L3.28034 7.53032L7.25001 3.56065V14.25V15H8.75001V14.25V3.56065L12.7197 7.53032L13.25 8.06065L14.3107 6.99999L13.7803 6.46966L8.70711 1.39644Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const StopIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg height={size} viewBox="0 0 16 16" width={size} style={{ color: 'currentcolor' }}>
      <path fillRule="evenodd" clipRule="evenodd" d="M3 3H13V13H3V3Z" fill="currentColor" />
    </svg>
  );
};

export const PaperclipIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
      className="-rotate-45"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8591 1.70735C10.3257 1.70735 9.81417 1.91925 9.437 2.29643L3.19455 8.53886C2.56246 9.17095 2.20735 10.0282 2.20735 10.9222C2.20735 11.8161 2.56246 12.6734 3.19455 13.3055C3.82665 13.9376 4.68395 14.2927 5.57786 14.2927C6.47178 14.2927 7.32908 13.9376 7.96117 13.3055L14.2036 7.06304L14.7038 6.56287L15.7041 7.56321L15.204 8.06337L8.96151 14.3058C8.06411 15.2032 6.84698 15.7074 5.57786 15.7074C4.30875 15.7074 3.09162 15.2032 2.19422 14.3058C1.29682 13.4084 0.792664 12.1913 0.792664 10.9222C0.792664 9.65305 1.29682 8.43592 2.19422 7.53852L8.43666 1.29609C9.07914 0.653606 9.95054 0.292664 10.8591 0.292664C11.7678 0.292664 12.6392 0.653606 13.2816 1.29609C13.9241 1.93857 14.2851 2.80997 14.2851 3.71857C14.2851 4.62718 13.9241 5.49858 13.2816 6.14106L13.2814 6.14133L7.0324 12.3835C7.03231 12.3836 7.03222 12.3837 7.03213 12.3838C6.64459 12.7712 6.11905 12.9888 5.57107 12.9888C5.02297 12.9888 4.49731 12.7711 4.10974 12.3835C3.72217 11.9959 3.50444 11.4703 3.50444 10.9222C3.50444 10.3741 3.72217 9.8484 4.10974 9.46084L4.11004 9.46054L9.877 3.70039L10.3775 3.20051L11.3772 4.20144L10.8767 4.70131L5.11008 10.4612C5.11005 10.4612 5.11003 10.4612 5.11 10.4613C4.98779 10.5835 4.91913 10.7493 4.91913 10.9222C4.91913 11.0951 4.98782 11.2609 5.11008 11.3832C5.23234 11.5054 5.39817 11.5741 5.57107 11.5741C5.74398 11.5741 5.9098 11.5054 6.03206 11.3832L6.03233 11.3829L12.2813 5.14072C12.2814 5.14063 12.2815 5.14054 12.2816 5.14045C12.6586 4.7633 12.8704 4.25185 12.8704 3.71857C12.8704 3.18516 12.6585 2.6736 12.2813 2.29643C11.9041 1.91925 11.3926 1.70735 10.8591 1.70735Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MoreHorizontalIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 8C4 8.82843 3.32843 9.5 2.5 9.5C1.67157 9.5 1 8.82843 1 8C1 7.17157 1.67157 6.5 2.5 6.5C3.32843 6.5 4 7.17157 4 8ZM9.5 8C9.5 8.82843 8.82843 9.5 8 9.5C7.17157 9.5 6.5 8.82843 6.5 8C6.5 7.17157 7.17157 6.5 8 6.5C8.82843 6.5 9.5 7.17157 9.5 8ZM13.5 9.5C14.3284 9.5 15 8.82843 15 8C15 7.17157 14.3284 6.5 13.5 6.5C12.6716 6.5 12 7.17157 12 8C12 8.82843 12.6716 9.5 13.5 9.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MessageIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.8914 10.4028L2.98327 10.6318C3.22909 11.2445 3.5 12.1045 3.5 13C3.5 13.3588 3.4564 13.7131 3.38773 14.0495C3.69637 13.9446 4.01409 13.8159 4.32918 13.6584C4.87888 13.3835 5.33961 13.0611 5.70994 12.7521L6.22471 12.3226L6.88809 12.4196C7.24851 12.4724 7.61994 12.5 8 12.5C11.7843 12.5 14.5 9.85569 14.5 7C14.5 4.14431 11.7843 1.5 8 1.5C4.21574 1.5 1.5 4.14431 1.5 7C1.5 8.18175 1.94229 9.29322 2.73103 10.2153L2.8914 10.4028ZM2.8135 15.7653C1.76096 16 1 16 1 16C1 16 1.43322 15.3097 1.72937 14.4367C1.88317 13.9834 2 13.4808 2 13C2 12.3826 1.80733 11.7292 1.59114 11.1903C0.591845 10.0221 0 8.57152 0 7C0 3.13401 3.58172 0 8 0C12.4183 0 16 3.13401 16 7C16 10.866 12.4183 14 8 14C7.54721 14 7.10321 13.9671 6.67094 13.9038C6.22579 14.2753 5.66881 14.6656 5 15C4.23366 15.3832 3.46733 15.6195 2.8135 15.7653Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CrossIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4697 13.5303L13 14.0607L14.0607 13L13.5303 12.4697L9.06065 7.99999L13.5303 3.53032L14.0607 2.99999L13 1.93933L12.4697 2.46966L7.99999 6.93933L3.53032 2.46966L2.99999 1.93933L1.93933 2.99999L2.46966 3.53032L6.93933 7.99999L2.46966 12.4697L1.93933 13L2.99999 14.0607L3.53032 13.5303L7.99999 9.06065L12.4697 13.5303Z"
      fill="currentColor"
    />
  </svg>
);

export const UndoIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 8C13.5 4.96643 11.0257 2.5 7.96452 2.5C5.42843 2.5 3.29365 4.19393 2.63724 6.5H5.25H6V8H5.25H0.75C0.335787 8 0 7.66421 0 7.25V2.75V2H1.5V2.75V5.23347C2.57851 2.74164 5.06835 1 7.96452 1C11.8461 1 15 4.13001 15 8C15 11.87 11.8461 15 7.96452 15C5.62368 15 3.54872 13.8617 2.27046 12.1122L1.828 11.5066L3.03915 10.6217L3.48161 11.2273C4.48831 12.6051 6.12055 13.5 7.96452 13.5C11.0257 13.5 13.5 11.0336 13.5 8Z"
      fill="currentColor"
    />
  </svg>
);

export const RedoIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 8C2.5 4.96643 4.97431 2.5 8.03548 2.5C10.5716 2.5 12.7064 4.19393 13.3628 6.5H10.75H10V8H10.75H15.25C15.6642 8 16 7.66421 16 7.25V2.75V2H14.5V2.75V5.23347C13.4215 2.74164 10.9316 1 8.03548 1C4.1539 1 1 4.13001 1 8C1 11.87 4.1539 15 8.03548 15C10.3763 15 12.4513 13.8617 13.7295 12.1122L14.172 11.5066L12.9609 10.6217L12.5184 11.2273C11.5117 12.6051 9.87945 13.5 8.03548 13.5C4.97431 13.5 2.5 11.0336 2.5 8Z"
      fill="currentColor"
    />
  </svg>
);

export const DeltaIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.67705 15H1L1.75 13.5L6.16147 4.67705L6.15836 4.67082L6.16667 4.66667L7.16147 2.67705L8 1L8.83853 2.67705L14.25 13.5L15 15H13.3229H2.67705ZM7 6.3541L10.5729 13.5H3.42705L7 6.3541Z"
      fill="currentColor"
    />
  </svg>
);

export const PenIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75 0.189331L9.28033 0.719661L15.2803 6.71966L15.8107 7.24999L15.2803 7.78032L13.7374 9.32322C13.1911 9.8696 12.3733 9.97916 11.718 9.65188L9.54863 13.5568C8.71088 15.0648 7.12143 16 5.39639 16H0.75H0V15.25V10.6036C0 8.87856 0.935237 7.28911 2.4432 6.45136L6.34811 4.28196C6.02084 3.62674 6.13039 2.80894 6.67678 2.26255L8.21967 0.719661L8.75 0.189331ZM7.3697 5.43035L10.5696 8.63029L8.2374 12.8283C7.6642 13.8601 6.57668 14.5 5.39639 14.5H2.56066L5.53033 11.5303L4.46967 10.4697L1.5 13.4393V10.6036C1.5 9.42331 2.1399 8.33579 3.17166 7.76259L7.3697 5.43035ZM12.6768 8.26256C12.5791 8.36019 12.4209 8.36019 12.3232 8.26255L12.0303 7.96966L8.03033 3.96966L7.73744 3.67677C7.63981 3.57914 7.63981 3.42085 7.73744 3.32321L8.75 2.31065L13.6893 7.24999L12.6768 8.26256Z"
      fill="currentColor"
    />
  </svg>
);

export const SummarizeIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.75 12H1V10.5H1.75H5.25H6V12H5.25H1.75ZM1.75 7.75H1V6.25H1.75H4.25H5V7.75H4.25H1.75ZM1.75 3.5H1V2H1.75H7.25H8V3.5H7.25H1.75ZM12.5303 14.7803C12.2374 15.0732 11.7626 15.0732 11.4697 14.7803L9.21967 12.5303L8.68934 12L9.75 10.9393L10.2803 11.4697L11.25 12.4393V2.75V2H12.75V2.75V12.4393L13.7197 11.4697L14.25 10.9393L15.3107 12L14.7803 12.5303L12.5303 14.7803Z"
      fill="currentColor"
    />
  </svg>
);

export const SidebarLeftIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.245 2.5H14.5V12.5C14.5 13.0523 14.0523 13.5 13.5 13.5H6.245V2.5ZM4.995 2.5H1.5V12.5C1.5 13.0523 1.94772 13.5 2.5 13.5H4.995V2.5ZM0 1H1.5H14.5H16V2.5V12.5C16 13.8807 14.8807 15 13.5 15H2.5C1.11929 15 0 13.8807 0 12.5V2.5V1Z"
      fill="currentColor"
    />
  </svg>
);

export const PlusIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75 1.75V1H7.25V1.75V6.75H2.25H1.5V8.25H2.25H7.25V13.25V14H8.75V13.25V8.25H13.75H14.5V6.75H13.75H8.75V1.75Z"
      fill="currentColor"
    />
  </svg>
);

export const CopyIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.75 0.5C1.7835 0.5 1 1.2835 1 2.25V9.75C1 10.7165 1.7835 11.5 2.75 11.5H3.75H4.5V10H3.75H2.75C2.61193 10 2.5 9.88807 2.5 9.75V2.25C2.5 2.11193 2.61193 2 2.75 2H8.25C8.38807 2 8.5 2.11193 8.5 2.25V3H10V2.25C10 1.2835 9.2165 0.5 8.25 0.5H2.75ZM7.75 4.5C6.7835 4.5 6 5.2835 6 6.25V13.75C6 14.7165 6.7835 15.5 7.75 15.5H13.25C14.2165 15.5 15 14.7165 15 13.75V6.25C15 5.2835 14.2165 4.5 13.25 4.5H7.75ZM7.5 6.25C7.5 6.11193 7.61193 6 7.75 6H13.25C13.3881 6 13.5 6.11193 13.5 6.25V13.75C13.5 13.8881 13.3881 14 13.25 14H7.75C7.61193 14 7.5 13.8881 7.5 13.75V6.25Z"
      fill="currentColor"
    />
  </svg>
);

export const ThumbUpIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.89531 2.23972C6.72984 2.12153 6.5 2.23981 6.5 2.44315V5.25001C6.5 6.21651 5.7165 7.00001 4.75 7.00001H2.5V13.5H12.1884C12.762 13.5 13.262 13.1096 13.4011 12.5532L14.4011 8.55318C14.5984 7.76425 14.0017 7.00001 13.1884 7.00001H9.25H8.5V6.25001V3.51458C8.5 3.43384 8.46101 3.35807 8.39531 3.31114L6.89531 2.23972ZM5 2.44315C5 1.01975 6.6089 0.191779 7.76717 1.01912L9.26717 2.09054C9.72706 2.41904 10 2.94941 10 3.51458V5.50001H13.1884C14.9775 5.50001 16.2903 7.18133 15.8563 8.91698L14.8563 12.917C14.5503 14.1412 13.4503 15 12.1884 15H1.75H1V14.25V6.25001V5.50001H1.75H4.75C4.88807 5.50001 5 5.38808 5 5.25001V2.44315Z"
      fill="currentColor"
    />
  </svg>
);

export const ThumbDownIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.89531 13.7603C6.72984 13.8785 6.5 13.7602 6.5 13.5569V10.75C6.5 9.7835 5.7165 9 4.75 9H2.5V2.5H12.1884C12.762 2.5 13.262 2.89037 13.4011 3.44683L14.4011 7.44683C14.5984 8.23576 14.0017 9 13.1884 9H9.25H8.5V9.75V12.4854C8.5 12.5662 8.46101 12.6419 8.39531 12.6889L6.89531 13.7603ZM5 13.5569C5 14.9803 6.6089 15.8082 7.76717 14.9809L9.26717 13.9095C9.72706 13.581 10 13.0506 10 12.4854V10.5H13.1884C14.9775 10.5 16.2903 8.81868 15.8563 7.08303L14.8563 3.08303C14.5503 1.85882 13.4503 1 12.1884 1H1.75H1V1.75V9.75V10.5H1.75H4.75C4.88807 10.5 5 10.6119 5 10.75V13.5569Z"
      fill="currentColor"
    />
  </svg>
);

export const ChevronDownIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0607 6.74999L11.5303 7.28032L8.7071 10.1035C8.31657 10.4941 7.68341 10.4941 7.29288 10.1035L4.46966 7.28032L3.93933 6.74999L4.99999 5.68933L5.53032 6.21966L7.99999 8.68933L10.4697 6.21966L11 5.68933L12.0607 6.74999Z"
      fill="currentColor"
    />
  </svg>
);

export const SparklesIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    height={size}
    strokeLinejoin="round"
    viewBox="0 0 16 16"
    width={size}
    style={{ color: 'currentcolor' }}
  >
    <path
      d="M2.5 0.5V0H3.5V0.5C3.5 1.60457 4.39543 2.5 5.5 2.5H6V3V3.5H5.5C4.39543 3.5 3.5 4.39543 3.5 5.5V6H3H2.5V5.5C2.5 4.39543 1.60457 3.5 0.5 3.5H0V3V2.5H0.5C1.60457 2.5 2.5 1.60457 2.5 0.5Z"
      fill="currentColor"
    />
    <path
      d="M14.5 4.5V5H13.5V4.5C13.5 3.94772 13.0523 3.5 12.5 3.5H12V3V2.5H12.5C13.0523 2.5 13.5 2.05228 13.5 1.5V1H14H14.5V1.5C14.5 2.05228 14.9477 2.5 15.5 2.5H16V3V3.5H15.5C14.9477 3.5 14.5 3.94772 14.5 4.5Z"
      fill="currentColor"
    />
    <path
      d="M8.40706 4.92939L8.5 4H9.5L9.59294 4.92939C9.82973 7.29734 11.7027 9.17027 14.0706 9.40706L15 9.5V10.5L14.0706 10.5929C11.7027 10.8297 9.82973 12.7027 9.59294 15.0706L9.5 16H8.5L8.40706 15.0706C8.17027 12.7027 6.29734 10.8297 3.92939 10.5929L3 10.5V9.5L3.92939 9.40706C6.29734 9.17027 8.17027 7.29734 8.40706 4.92939Z"
      fill="currentColor"
    />
  </svg>
);

export const GifIcon = ({ size = 16, className }: { size?: number; className?: string }) => (
  <svg
    strokeLinejoin="round"
    viewBox="0 0 24 24"
    width={size}
    style={{ color: 'currentcolor' }}
    className={className}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.75 8.25v7.5m6-7.5h-3V12m0 0v3.75m0-3.75H18M9.75 9.348c-1.03-1.464-2.698-1.464-3.728 0-1.03 1.465-1.03 3.84 0 5.304 1.03 1.464 2.699 1.464 3.728 0V12h-1.5M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
    />
  </svg>
);

export const CheckCirclFillIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      viewBox="0 0 16 16"
      width={size}
      style={{ color: 'currentcolor' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM11.5303 6.53033L12.0607 6L11 4.93934L10.4697 5.46967L6.5 9.43934L5.53033 8.46967L5 7.93934L3.93934 9L4.46967 9.53033L5.96967 11.0303C6.26256 11.3232 6.73744 11.3232 7.03033 11.0303L11.5303 6.53033Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const AppleIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.0055 11.9103C13.7853 12.3994 13.5247 12.8496 13.2228 13.2635C12.8112 13.8278 12.4742 14.2185 12.2145 14.4354C11.812 14.7914 11.3806 14.9737 10.9187 14.9841C10.5871 14.9841 10.1873 14.8934 9.72178 14.7093C9.25477 14.5261 8.8256 14.4354 8.43317 14.4354C8.02161 14.4354 7.58021 14.5261 7.10808 14.7093C6.63523 14.8934 6.2543 14.9893 5.96306 14.9988C5.52014 15.0169 5.07865 14.8294 4.63797 14.4354C4.3567 14.1994 4.0049 13.795 3.58345 13.2221C3.13126 12.6102 2.75951 11.9007 2.46827 11.0919C2.15636 10.2182 2 9.37218 2 8.55312C2 7.61489 2.21081 6.80568 2.63307 6.12756C2.96493 5.58287 3.40642 5.15321 3.95898 4.83779C4.51153 4.52236 5.10857 4.36163 5.75153 4.35134C6.10334 4.35134 6.56468 4.45599 7.138 4.66167C7.7097 4.86803 8.07678 4.97268 8.23772 4.97268C8.35805 4.97268 8.76584 4.85032 9.45714 4.60636C10.1109 4.38012 10.6626 4.28644 11.1146 4.32334C12.3394 4.4184 13.2596 4.88272 13.8716 5.71924C12.7762 6.35752 12.2343 7.2515 12.2451 8.39834C12.255 9.29164 12.592 10.035 13.2542 10.6252C13.5544 10.8992 13.8896 11.1109 14.2625 11.2613C14.1816 11.4868 14.0962 11.7029 14.0055 11.9103ZM11.1964 1.28008C11.1964 1.98024 10.9304 2.63398 10.4002 3.23907C9.76042 3.9584 8.98654 4.37407 8.14732 4.30848C8.13663 4.22448 8.13043 4.13608 8.13043 4.04318C8.13043 3.37103 8.4347 2.65169 8.97504 2.06354C9.2448 1.76574 9.58789 1.51813 10.0039 1.32061C10.4191 1.12603 10.8118 1.01842 11.1811 1C11.1919 1.0936 11.1964 1.18721 11.1964 1.28007V1.28008Z" />
  </svg>
);

export const LinuxIcon = () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.1894 6.25391C12.3166 5.81981 12.3868 5.36199 12.3868 4.88709C12.3868 2.18806 10.1997 0 7.50016 0C4.80161 0 2.61355 2.18759 2.61355 4.88709C2.61355 5.36199 2.68424 5.81981 2.81091 6.25391C2.19558 6.74827 -0.192693 8.89031 0.789848 11.6681C0.789848 11.6681 1.62105 11.5969 2.30375 10.3345C2.51107 11.1424 2.89726 11.8764 3.42387 12.4898C2.65245 12.7171 2.12916 13.1578 2.12916 13.6635C2.12916 14.4017 3.24312 15 4.61659 15C5.54884 15 6.36059 14.7239 6.78615 14.3168C7.02052 14.3477 7.25678 14.369 7.49921 14.369C7.74212 14.369 7.97886 14.3477 8.21228 14.3168C8.63879 14.7239 9.45006 15 10.3823 15C11.7563 15 12.8707 14.4013 12.8707 13.6635C12.8707 13.1583 12.3469 12.7171 11.5755 12.4898C12.1016 11.8764 12.4888 11.1424 12.6961 10.3345C13.3783 11.5965 14.2086 11.6681 14.2086 11.6681C15.1925 8.88984 12.8043 6.74779 12.1894 6.25391Z"
      fill="currentColor"
    ></path>
  </svg>
);

export const WindowsIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.68797 2H2V7.68773H7.68797V2Z" />
    <path d="M14 2H8.31203V7.68772H14V2Z" />
    <path d="M7.68797 8.31228H2V14H7.68797V8.31228Z" />
    <path d="M14 8.31228H8.31203V14H14V8.31228Z" />
  </svg>
);

export const WebIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM7.41189 13.4689C7.52699 13.4812 7.625 13.3892 7.625 13.2735V11.1019C7.625 10.986 7.52684 10.8941 7.41169 10.9065C6.86713 10.9653 6.36508 11.1031 5.93222 11.2936C5.84072 11.3339 5.79715 11.4379 5.83032 11.5322C5.96714 11.9212 6.12298 12.2792 6.29211 12.6C6.4321 12.8655 6.57839 13.1002 6.72659 13.3033C6.75438 13.3414 6.79526 13.3679 6.84136 13.3777C7.02819 13.4178 7.21855 13.4484 7.41189 13.4689ZM8.58831 10.9065C8.47316 10.8941 8.375 10.986 8.375 11.1019V13.2735C8.375 13.3892 8.47301 13.4812 8.58811 13.4689C8.78145 13.4484 8.97181 13.4178 9.15864 13.3777C9.20474 13.3679 9.24562 13.3414 9.27341 13.3033C9.42161 13.1002 9.5679 12.8655 9.70789 12.6C9.87702 12.2792 10.0329 11.9212 10.1697 11.5322C10.2028 11.4379 10.1593 11.3339 10.0678 11.2936C9.63492 11.1031 9.13287 10.9653 8.58831 10.9065ZM8.56285 10.1504C8.45748 10.1408 8.375 10.0537 8.375 9.94787V8.575C8.375 8.46454 8.46454 8.375 8.575 8.375H10.5372C10.6502 8.375 10.7409 8.46864 10.7352 8.58153C10.7024 9.22171 10.6169 9.83286 10.4908 10.4016C10.4636 10.524 10.3303 10.5883 10.2139 10.5415C9.7168 10.3416 9.15763 10.2042 8.56285 10.1504ZM7.425 7.625C7.53546 7.625 7.625 7.53546 7.625 7.425V6.05213C7.625 5.94633 7.54252 5.85918 7.43715 5.84964C6.84237 5.79581 6.2832 5.65843 5.78606 5.45852C5.66973 5.41173 5.53635 5.47596 5.50922 5.59838C5.38314 6.16714 5.29755 6.77829 5.26484 7.41847C5.25907 7.53136 5.34982 7.625 5.46285 7.625H7.425Z"
    />
  </svg>
);

export function BetterAuthLogo({ className }: { className?: string }) {
  return (
    <svg
      width="121"
      height="14"
      viewBox="0 0 121 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M5.37222 0H0.333008V13.9999H5.37222V0Z" fill="currentColor" />
      <path d="M21.2458 0H15.8916V13.9999H21.2458V0Z" fill="currentColor" />
      <path d="M21.0884 4.51108V0L10.9785 0V4.51108L21.0884 4.51108Z" fill="currentColor" />
      <path d="M21.2456 14V9.48889H10.9782V14H21.2456Z" fill="currentColor" />
      <path d="M10.9785 9.48885V4.51111H5.37239V9.48885H10.9785Z" fill="currentColor" />
      <path
        d="M27.3208 11.9067V2.12876H30.7226C31.8937 2.12876 32.7721 2.33993 33.3576 2.76226C33.9432 3.1846 34.2359 3.85023 34.2359 4.75917C34.2359 5.31004 34.0779 5.77369 33.7619 6.15011C33.4552 6.51736 33.0277 6.75148 32.4793 6.85247C33.1578 6.94428 33.6876 7.20595 34.0686 7.63746C34.459 8.0598 34.6542 8.58771 34.6542 9.22121C34.6542 10.1118 34.3614 10.782 33.7759 11.2319C33.1903 11.6818 32.3584 11.9067 31.2803 11.9067H27.3208ZM28.5198 6.35669H30.7226C31.4476 6.35669 32.0053 6.22356 32.3956 5.95731C32.786 5.68187 32.9812 5.30086 32.9812 4.81425C32.9812 3.79514 32.2283 3.28559 30.7226 3.28559H28.5198V6.35669ZM28.5198 10.7499H31.2803C31.9588 10.7499 32.4793 10.6122 32.8418 10.3367C33.2135 10.0613 33.3994 9.6665 33.3994 9.15236C33.3994 8.63821 33.2135 8.23883 32.8418 7.95421C32.4793 7.66042 31.9588 7.51352 31.2803 7.51352H28.5198V10.7499ZM36.5382 11.9067V2.12876H42.7563V3.28559H37.7372V6.43932H42.589V7.5686H37.7372V10.7499H42.8678V11.9067H36.5382ZM46.9046 11.9067V3.28559H43.8234V2.12876H51.1847V3.28559H48.1036V11.9067H46.9046ZM54.7332 11.9067V3.28559H51.652V2.12876H59.0133V3.28559H55.9322V11.9067H54.7332ZM60.0378 11.9067V2.12876H66.2558V3.28559H61.2368V6.43932H66.0885V7.5686H61.2368V10.7499H66.3673V11.9067H60.0378ZM68.3022 11.9067V2.12876H72.0526C73.0935 2.12876 73.9161 2.39502 74.5203 2.92752C75.1244 3.46003 75.4265 4.18075 75.4265 5.08969C75.4265 5.46612 75.3475 5.81041 75.1895 6.12257C75.0315 6.42555 74.827 6.68262 74.576 6.89379C74.3251 7.10496 74.0509 7.25185 73.7535 7.33449C74.1903 7.40793 74.5342 7.58238 74.7852 7.85781C75.0454 8.13325 75.1988 8.52345 75.2452 9.02841L75.5241 11.9067H74.3111L74.06 9.15236C74.023 8.74838 73.8743 8.45 73.614 8.25719C73.3631 8.06439 72.9495 7.96799 72.3732 7.96799H69.5012V11.9067H68.3022ZM69.5012 6.81116H72.2059C72.8101 6.81116 73.2887 6.65967 73.6419 6.35669C73.9951 6.05371 74.1717 5.6222 74.1717 5.06215C74.1717 4.49291 73.9905 4.05681 73.628 3.75383C73.2655 3.44167 72.7404 3.28559 72.0526 3.28559H69.5012V6.81116ZM77.0002 8.43622V7.34826H81.6149V8.43622H77.0002ZM82.5063 11.9067L86.0754 2.12876H87.6927L91.2618 11.9067H89.9513L88.9614 9.12481H84.8067L83.8168 11.9067H82.5063ZM85.211 7.96799H88.5571L86.884 3.16164L85.211 7.96799ZM96.1323 12.1271C95.3701 12.1271 94.7056 11.9802 94.1386 11.6864C93.5809 11.3926 93.1487 10.9748 92.842 10.4331C92.5446 9.88226 92.3959 9.23499 92.3959 8.49131V2.11499H93.5949V8.49131C93.5949 9.28089 93.8133 9.89144 94.2501 10.323C94.6963 10.7545 95.3236 10.9702 96.1323 10.9702C96.9316 10.9702 97.5497 10.7545 97.9865 10.323C98.4327 9.89144 98.6557 9.28089 98.6557 8.49131V2.11499H99.8547V8.49131C99.8547 9.23499 99.7014 9.88226 99.3947 10.4331C99.0972 10.9748 98.6697 11.3926 98.112 11.6864C97.5543 11.9802 96.8944 12.1271 96.1323 12.1271ZM104.183 11.9067V3.28559H101.102V2.12876H108.463V3.28559H105.382V11.9067H104.183ZM109.488 11.9067V2.12876H110.687V6.41178H115.664V2.12876H116.863V11.9067H115.664V7.5686H110.687V11.9067H109.488ZM118.758 11.9067V10.3505H120.333V11.9067H118.758Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function BrowserUseLogo({ className }: { className?: string }) {
  return (
    <svg
      width="118"
      height="18"
      viewBox="0 0 118 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_20099_537)">
        <mask
          id="mask0_20099_537"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="2"
          width="15"
          height="14"
        >
          <path d="M14.8561 2.17578H0V15.8241H14.8561V2.17578Z" fill="white" />
        </mask>
        <g mask="url(#mask0_20099_537)">
          <path
            d="M14.5429 7.50475C12.2738 6.70699 14.146 3.65211 11.025 3.72963C7.21135 3.82441 1.23533 9.33459 1.84566 12.915C2.14897 14.688 3.65603 13.9436 4.36372 14.2021C4.83364 14.3727 5.38968 15.1428 5.99065 15.2652C3.33212 16.6694 -0.0827202 15.3324 0.00152888 12.3223C0.123222 7.88898 7.09341 1.45872 12.0622 2.24096C14.8368 2.67861 15.1813 5.3889 14.5429 7.50475Z"
            fill="currentColor"
          />
          <path
            d="M3.68602 10.0583L5.88403 11.9639C7.28443 13.1201 11.0026 15.1377 12.6876 13.7697C14.674 12.1569 10.4728 6.58644 8.53883 5.69736L10.2369 4.99609C12.8823 6.77252 16.9037 12.5463 13.6274 15.0602C11.5137 16.6816 8.10631 15.3083 6.10305 14.1005C4.57721 13.1804 2.37173 11.8606 3.68602 10.0566V10.0583Z"
            fill="currentColor"
          />
          <path
            d="M5.99259 2.8251C5.28116 2.84233 4.72509 3.6935 4.20275 3.8434C3.73846 3.97608 3.09626 3.61253 2.39793 4.09323C1.64156 4.61359 1.9 7.09816 0.449034 7.71672C-0.444006 5.30623 0.11198 2.43226 3.33779 2.18587C3.58679 2.16691 6.35581 2.33577 5.99259 2.82338V2.8251Z"
            fill="currentColor"
          />
          <path
            d="M11.3058 10.0582C12.4965 11.8708 10.3378 13.9419 8.54053 12.2895L11.3058 10.0582Z"
            fill="currentColor"
          />
        </g>
      </g>
      <path
        d="M113.376 14.5984C112.479 14.5984 111.706 14.429 111.059 14.0903C110.415 13.748 109.919 13.2645 109.571 12.6399C109.223 12.0118 109.048 11.269 109.048 10.4115C109.048 9.57522 109.223 8.84124 109.571 8.20959C109.919 7.57794 110.409 7.08568 111.042 6.7328C111.678 6.37993 112.424 6.20349 113.279 6.20349C113.855 6.20349 114.391 6.28995 114.887 6.46285C115.386 6.63224 115.822 6.88807 116.193 7.23036C116.568 7.57265 116.859 8.00316 117.067 8.52189C117.276 9.03708 117.38 9.6405 117.38 10.3321V10.9514H110.014V9.55405H115.102C115.102 9.2294 115.027 8.94181 114.875 8.69127C114.724 8.44072 114.514 8.24488 114.245 8.10373C113.98 7.95905 113.671 7.88671 113.319 7.88671C112.952 7.88671 112.626 7.96611 112.342 8.1249C112.062 8.28017 111.843 8.49013 111.684 8.75478C111.524 9.01591 111.443 9.30703 111.439 9.62815V10.9567C111.439 11.359 111.519 11.7066 111.678 11.9995C111.841 12.2924 112.07 12.5182 112.365 12.677C112.66 12.8358 113.011 12.9152 113.416 12.9152C113.684 12.9152 113.931 12.8799 114.154 12.8093C114.377 12.7388 114.569 12.6329 114.728 12.4917C114.887 12.3506 115.008 12.1777 115.091 11.973L117.329 12.1106C117.215 12.6117 116.982 13.0493 116.63 13.4233C116.282 13.7939 115.831 14.0832 115.278 14.2914C114.729 14.4961 114.095 14.5984 113.376 14.5984Z"
        fill="currentColor"
      />
      <path
        d="M107.678 8.62775L105.464 8.75478C105.426 8.57835 105.344 8.41955 105.219 8.2784C105.094 8.13372 104.93 8.01904 104.725 7.93435C104.525 7.84613 104.284 7.80202 104.004 7.80202C103.629 7.80202 103.313 7.87612 103.056 8.02433C102.798 8.16901 102.669 8.36309 102.669 8.60658C102.669 8.80066 102.753 8.96475 102.919 9.09884C103.086 9.23293 103.372 9.34056 103.777 9.42172L105.356 9.71813C106.204 9.88046 106.836 10.1416 107.252 10.5015C107.669 10.8615 107.877 11.3343 107.877 11.9201C107.877 12.4529 107.709 12.9205 107.372 13.3228C107.039 13.725 106.58 14.0391 105.997 14.2649C105.418 14.4873 104.75 14.5984 103.993 14.5984C102.838 14.5984 101.918 14.3743 101.232 13.9262C100.551 13.4745 100.152 12.8605 100.034 12.0842L102.414 11.9677C102.486 12.2959 102.66 12.5464 102.936 12.7193C103.213 12.8887 103.567 12.9734 103.998 12.9734C104.422 12.9734 104.763 12.8975 105.021 12.7458C105.282 12.5905 105.414 12.3912 105.418 12.1477C105.414 11.943 105.322 11.7754 105.14 11.6448C104.958 11.5107 104.678 11.4084 104.299 11.3378L102.789 11.0573C101.937 10.8985 101.303 10.6233 100.886 10.2316C100.473 9.83988 100.267 9.34056 100.267 8.73361C100.267 8.21135 100.418 7.76144 100.721 7.38386C101.028 7.00628 101.458 6.71516 102.011 6.51049C102.567 6.30583 103.218 6.20349 103.964 6.20349C105.066 6.20349 105.933 6.42051 106.565 6.85455C107.201 7.28858 107.572 7.87965 107.678 8.62775Z"
        fill="currentColor"
      />
      <path
        d="M95.9835 3.59924H98.4426V10.6391C98.4426 11.4296 98.2401 12.1212 97.835 12.714C97.4336 13.3069 96.8714 13.7691 96.1482 14.1008C95.4251 14.429 94.5827 14.5931 93.621 14.5931C92.6555 14.5931 91.8112 14.429 91.088 14.1008C90.3649 13.7691 89.8026 13.3069 89.4013 12.714C89 12.1212 88.7993 11.4296 88.7993 10.6391V3.59924H91.2584V10.4433C91.2584 10.8561 91.355 11.2231 91.5481 11.5442C91.7449 11.8654 92.0213 12.1177 92.3772 12.3012C92.7331 12.4847 93.1477 12.5764 93.621 12.5764C94.098 12.5764 94.5126 12.4847 94.8647 12.3012C95.2206 12.1177 95.4951 11.8654 95.6882 11.5442C95.8851 11.2231 95.9835 10.8561 95.9835 10.4433V3.59924Z"
        fill="currentColor"
      />
      <path
        d="M78.5083 14.4396V6.30932H80.8538V7.72788H80.9447C81.1037 7.22327 81.3706 6.84216 81.7455 6.58456C82.1203 6.32344 82.5519 6.19287 83.0403 6.19287C83.1615 6.19287 83.2921 6.19993 83.4322 6.21404C83.5723 6.22816 83.6953 6.24757 83.8013 6.27227V8.27307C83.6878 8.24132 83.5306 8.21309 83.33 8.18838C83.1293 8.16368 82.9457 8.15133 82.7791 8.15133C82.4232 8.15133 82.1051 8.22367 81.825 8.36835C81.5486 8.5095 81.329 8.70711 81.1662 8.96118C81.0072 9.21525 80.9277 9.50814 80.9277 9.83984V14.4396H78.5083Z"
        fill="currentColor"
      />
      <path
        d="M72.9257 14.5984C72.0284 14.5984 71.256 14.429 70.6086 14.0903C69.9649 13.748 69.469 13.2645 69.1206 12.6399C68.7723 12.0118 68.5981 11.269 68.5981 10.4115C68.5981 9.57522 68.7723 8.84124 69.1206 8.20959C69.469 7.57794 69.9593 7.08568 70.5916 6.7328C71.2276 6.37993 71.9735 6.20349 72.8292 6.20349C73.4047 6.20349 73.9404 6.28995 74.4364 6.46285C74.9362 6.63224 75.3716 6.88807 75.7426 7.23036C76.1174 7.57265 76.409 8.00316 76.6172 8.52189C76.8255 9.03708 76.9296 9.6405 76.9296 10.3321V10.9514H69.5636V9.55405H74.6522C74.6522 9.2294 74.5765 8.94181 74.425 8.69127C74.2736 8.44072 74.0635 8.24488 73.7946 8.10373C73.5296 7.95905 73.221 7.88671 72.8689 7.88671C72.5017 7.88671 72.1761 7.96611 71.8921 8.1249C71.6119 8.28017 71.3923 8.49013 71.2333 8.75478C71.0743 9.01591 70.9929 9.30703 70.9891 9.62815V10.9567C70.9891 11.359 71.0686 11.7066 71.2276 11.9995C71.3904 12.2924 71.6195 12.5182 71.9148 12.677C72.2101 12.8358 72.5604 12.9152 72.9655 12.9152C73.2343 12.9152 73.4804 12.8799 73.7038 12.8093C73.9272 12.7388 74.1184 12.6329 74.2774 12.4917C74.4364 12.3506 74.5575 12.1777 74.6408 11.973L76.8785 12.1106C76.7649 12.6117 76.532 13.0493 76.1799 13.4233C75.8316 13.7939 75.381 14.0832 74.8283 14.2914C74.2793 14.4961 73.6451 14.5984 72.9257 14.5984Z"
        fill="currentColor"
      />
      <path
        d="M67.2282 8.62775L65.0133 8.75478C64.9755 8.57835 64.8941 8.41955 64.7691 8.2784C64.6442 8.13372 64.4795 8.01904 64.275 7.93435C64.0744 7.84613 63.8339 7.80202 63.5538 7.80202C63.1789 7.80202 62.8628 7.87612 62.6053 8.02433C62.3479 8.16901 62.2191 8.36309 62.2191 8.60658C62.2191 8.80066 62.3024 8.96475 62.469 9.09884C62.6356 9.23293 62.9215 9.34056 63.3266 9.42172L64.9054 9.71813C65.7535 9.88046 66.3858 10.1416 66.8023 10.5015C67.2188 10.8615 67.427 11.3343 67.427 11.9201C67.427 12.4529 67.2585 12.9205 66.9215 13.3228C66.5884 13.725 66.1302 14.0391 65.5472 14.2649C64.9679 14.4873 64.2996 14.5984 63.5424 14.5984C62.3876 14.5984 61.4676 14.3743 60.7823 13.9262C60.1008 13.4745 59.7014 12.8605 59.584 12.0842L61.9636 11.9677C62.0355 12.2959 62.2097 12.5464 62.4861 12.7193C62.7625 12.8887 63.1165 12.9734 63.5481 12.9734C63.9721 12.9734 64.3129 12.8975 64.5703 12.7458C64.8316 12.5905 64.9641 12.3912 64.9679 12.1477C64.9641 11.943 64.8713 11.7754 64.6896 11.6448C64.5079 11.5107 64.2277 11.4084 63.8491 11.3378L62.3384 11.0573C61.4865 10.8985 60.8523 10.6233 60.4359 10.2316C60.0232 9.83988 59.8168 9.34056 59.8168 8.73361C59.8168 8.21135 59.9683 7.76144 60.2712 7.38386C60.5778 7.00628 61.0076 6.71516 61.5604 6.51049C62.1169 6.30583 62.7681 6.20349 63.514 6.20349C64.6158 6.20349 65.4828 6.42051 66.1151 6.85455C66.7512 7.28858 67.1222 7.87965 67.2282 8.62775Z"
        fill="currentColor"
      />
      <path
        d="M48.0878 14.4396L45.7139 6.30933H48.1616L49.5133 11.7718H49.5928L51.0012 6.30933H53.4035L54.8347 11.7401H54.9085L56.2375 6.30933H58.6795L56.3113 14.4396H53.75L52.2507 9.32642H52.1428L50.6434 14.4396H48.0878Z"
        fill="currentColor"
      />
      <path
        d="M40.7188 14.5984C39.8366 14.5984 39.0737 14.4237 38.4301 14.0744C37.7902 13.7215 37.2961 13.231 36.9478 12.6029C36.5995 11.9712 36.4253 11.239 36.4253 10.4062C36.4253 9.5664 36.5995 8.83242 36.9478 8.2043C37.2961 7.57265 37.7902 7.08215 38.4301 6.7328C39.0737 6.37993 39.8366 6.20349 40.7188 6.20349C41.601 6.20349 42.362 6.37993 43.0018 6.7328C43.6455 7.08215 44.1415 7.57265 44.4898 8.2043C44.8381 8.83242 45.0123 9.5664 45.0123 10.4062C45.0123 11.239 44.8381 11.9712 44.4898 12.6029C44.1415 13.231 43.6455 13.7215 43.0018 14.0744C42.362 14.4237 41.601 14.5984 40.7188 14.5984ZM40.7301 12.8517C41.1315 12.8517 41.4666 12.7458 41.7354 12.5341C42.0042 12.3188 42.2067 12.0259 42.343 11.6554C42.4831 11.2849 42.5532 10.8632 42.5532 10.3904C42.5532 9.91751 42.4831 9.49582 42.343 9.1253C42.2067 8.75478 42.0042 8.4619 41.7354 8.24664C41.4666 8.03139 41.1315 7.92376 40.7301 7.92376C40.325 7.92376 39.9843 8.03139 39.7079 8.24664C39.4353 8.4619 39.2289 8.75478 39.0889 9.1253C38.9525 9.49582 38.8844 9.91751 38.8844 10.3904C38.8844 10.8632 38.9525 11.2849 39.0889 11.6554C39.2289 12.0259 39.4353 12.3188 39.7079 12.5341C39.9843 12.7458 40.325 12.8517 40.7301 12.8517Z"
        fill="currentColor"
      />
      <path
        d="M30.6396 14.4396V6.30932H32.9852V7.72788H33.076C33.2351 7.22327 33.502 6.84216 33.8768 6.58456C34.2516 6.32344 34.6833 6.19287 35.1717 6.19287C35.2928 6.19287 35.4235 6.19993 35.5635 6.21404C35.7036 6.22816 35.8267 6.24757 35.9327 6.27227V8.27307C35.8191 8.24132 35.662 8.21309 35.4613 8.18838C35.2606 8.16368 35.077 8.15133 34.9104 8.15133C34.5545 8.15133 34.2365 8.22367 33.9563 8.36835C33.6799 8.5095 33.4603 8.70711 33.2975 8.96118C33.1385 9.21525 33.059 9.50814 33.059 9.83984V14.4396H30.6396Z"
        fill="currentColor"
      />
      <path
        d="M20.1118 14.4396V3.59924H24.7688C25.6245 3.59924 26.3381 3.71746 26.9099 3.95388C27.4816 4.19031 27.9113 4.51849 28.199 4.93841C28.4868 5.3548 28.6307 5.83471 28.6307 6.37814C28.6307 6.80159 28.5398 7.17388 28.3581 7.49499C28.1763 7.81258 27.9264 8.07371 27.6084 8.27838C27.2941 8.47952 26.9345 8.62243 26.5293 8.70712V8.81298C26.9723 8.83063 27.3869 8.94708 27.7731 9.16233C28.1631 9.37759 28.4792 9.67929 28.7215 10.0675C28.9638 10.4521 29.085 10.9108 29.085 11.4437C29.085 12.0189 28.9317 12.5323 28.625 12.984C28.3221 13.4321 27.8734 13.7868 27.279 14.0479C26.6846 14.309 25.952 14.4396 25.0811 14.4396H20.1118ZM22.5709 12.5658H24.5757C25.261 12.5658 25.7608 12.4441 26.075 12.2006C26.3893 11.9536 26.5464 11.6254 26.5464 11.2161C26.5464 10.9161 26.4688 10.6515 26.3135 10.4221C26.1583 10.1927 25.9368 10.0128 25.6491 9.8822C25.3651 9.75163 25.0262 9.68635 24.6325 9.68635H22.5709V12.5658ZM22.5709 8.13546H24.394C24.7309 8.13546 25.03 8.08077 25.2913 7.97138C25.5563 7.85846 25.7645 7.69966 25.916 7.49499C26.0712 7.29032 26.1488 7.04508 26.1488 6.75925C26.1488 6.36755 25.9993 6.05173 25.7002 5.81177C25.4049 5.57182 24.9846 5.45184 24.4394 5.45184H22.5709V8.13546Z"
        fill="currentColor"
      />
      <defs>
        <clipPath id="clip0_20099_537">
          <rect width="14.8561" height="13.6484" fill="white" transform="translate(0 2.17578)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CalComLogo({ className }: { className?: string }) {
  return (
    <svg
      width="65"
      height="14"
      viewBox="0 0 65 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_20099_525)">
        <path
          d="M7.04002 13.2472C3.40466 13.2472 0.666504 10.3577 0.666504 6.79031C0.666504 3.21108 3.26484 0.297729 7.04002 0.297729C9.0441 0.297729 10.4306 0.916069 11.5142 2.33113L9.76648 3.79374C9.03244 3.00892 8.1469 2.61652 7.04002 2.61652C4.58148 2.61652 3.22988 4.50722 3.22988 6.79031C3.22988 9.07345 4.70965 10.9285 7.04002 10.9285C8.13524 10.9285 9.06742 10.5361 9.80146 9.75125L11.5259 11.2733C10.4889 12.6289 9.06742 13.2472 7.04002 13.2472Z"
          fill="currentColor"
        />
        <path
          d="M19.053 3.74563H21.4066V13.0208H19.053V11.6652C18.5636 12.6284 17.7479 13.2705 16.1866 13.2705C13.6932 13.2705 11.7007 11.0944 11.7007 8.41889C11.7007 5.74335 13.6932 3.56726 16.1866 3.56726C17.7363 3.56726 18.5636 4.20939 19.053 5.17258V3.74563ZM19.1228 8.41889C19.1228 6.96817 18.1324 5.76714 16.5711 5.76714C15.068 5.76714 14.0893 6.98001 14.0893 8.41889C14.0893 9.82201 15.068 11.0706 16.5711 11.0706C18.1208 11.0706 19.1228 9.85771 19.1228 8.41889Z"
          fill="currentColor"
        />
        <path d="M23.0728 0H25.4264V13.009H23.0728V0Z" fill="currentColor" />
        <path
          d="M26.4751 11.7843C26.4751 11.0233 27.081 10.3811 27.9083 10.3811C28.7356 10.3811 29.3182 11.0233 29.3182 11.7843C29.3182 12.5691 28.7239 13.2112 27.9083 13.2112C27.0927 13.2112 26.4751 12.5691 26.4751 11.7843Z"
          fill="currentColor"
        />
        <path
          d="M38.3248 11.5225C37.4509 12.5927 36.1226 13.2705 34.5496 13.2705C31.7415 13.2705 29.6792 11.0944 29.6792 8.41889C29.6792 5.74335 31.7415 3.56726 34.5496 3.56726C36.0643 3.56726 37.381 4.20939 38.2549 5.22014L36.4372 6.7541C35.9828 6.18333 35.3885 5.75524 34.5496 5.75524C33.0465 5.75524 32.0678 6.96817 32.0678 8.40699C32.0678 9.84581 33.0465 11.0587 34.5496 11.0587C35.4585 11.0587 36.0876 10.5831 36.5537 9.94095L38.3248 11.5225Z"
          fill="currentColor"
        />
        <path
          d="M38.5229 8.41889C38.5229 5.74335 40.5853 3.56726 43.3933 3.56726C46.2014 3.56726 48.2638 5.74335 48.2638 8.41889C48.2638 11.0944 46.2014 13.2705 43.3933 13.2705C40.5853 13.2586 38.5229 11.0944 38.5229 8.41889ZM45.8752 8.41889C45.8752 6.96817 44.8964 5.76714 43.3933 5.76714C41.8903 5.75524 40.9115 6.96817 40.9115 8.41889C40.9115 9.85771 41.8903 11.0706 43.3933 11.0706C44.8964 11.0706 45.8752 9.85771 45.8752 8.41889Z"
          fill="currentColor"
        />
        <path
          d="M64.1797 7.34887V13.0091H61.8263V7.93152C61.8263 6.32622 61.0806 5.63653 59.9621 5.63653C58.9134 5.63653 58.1677 6.15974 58.1677 7.93152V13.0091H55.814V7.93152C55.814 6.32622 55.0566 5.63653 53.9497 5.63653C52.9011 5.63653 51.9806 6.15974 51.9806 7.93152V13.0091H49.627V3.73394H51.9806V5.01819C52.4699 4.01933 53.3555 3.5199 54.7188 3.5199C56.0121 3.5199 57.0957 4.16202 57.6899 5.24412C58.2842 4.13824 59.1581 3.5199 60.7427 3.5199C62.6769 3.53179 64.1797 5.0063 64.1797 7.34887Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_20099_525">
          <rect width="64" height="14" fill="white" transform="translate(0.666504)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function GitHubCircledLogo({ className }: { className?: string }) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_19962_15690)">
        <path
          fill-rule="evenodd"
          clipRule="evenodd"
          d="M16.0132 0C7.15833 0 0 7.2111 0 16.1322C0 23.2633 4.58659 29.2997 10.9494 31.4362C11.7449 31.5968 12.0363 31.089 12.0363 30.6619C12.0363 30.2879 12.0101 29.006 12.0101 27.6703C7.5556 28.632 6.62799 25.7472 6.62799 25.7472C5.91212 23.8776 4.85143 23.3971 4.85143 23.3971C3.39348 22.4088 4.95763 22.4088 4.95763 22.4088C6.57489 22.5157 7.4235 24.0648 7.4235 24.0648C8.85491 26.5218 11.1615 25.8276 12.0894 25.4001C12.2218 24.3585 12.6463 23.6373 13.097 23.2368C9.54422 22.8628 5.80625 21.474 5.80625 15.2774C5.80625 13.5146 6.44214 12.0724 7.44973 10.9507C7.29075 10.5502 6.73386 8.89391 7.60903 6.67715C7.60903 6.67715 8.96111 6.24973 12.0098 8.33309C13.315 7.97996 14.6611 7.80032 16.0132 7.79881C17.3653 7.79881 18.7436 7.98597 20.0164 8.33309C23.0654 6.24973 24.4175 6.67715 24.4175 6.67715C25.2926 8.89391 24.7354 10.5502 24.5764 10.9507C25.6106 12.0724 26.2202 13.5146 26.2202 15.2774C26.2202 21.474 22.4823 22.8359 18.9029 23.2368C19.4864 23.7442 19.9898 24.7056 19.9898 26.2281C19.9898 28.3914 19.9636 30.1277 19.9636 30.6616C19.9636 31.089 20.2553 31.5968 21.0505 31.4365C27.4133 29.2994 31.9999 23.2633 31.9999 16.1322C32.0261 7.2111 24.8416 0 16.0132 0Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_19962_15690">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function GitHubLogo({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.99994 15.1666V12.4999C10.0927 11.6648 9.85323 10.8267 9.33328 10.1666C11.3333 10.1666 13.3333 8.83325 13.3333 6.49992C13.3866 5.66659 13.1533 4.84659 12.6666 4.16659C12.8533 3.39992 12.8533 2.59992 12.6666 1.83325C12.6666 1.83325 11.9999 1.83325 10.6666 2.83325C8.90661 2.49992 7.09328 2.49992 5.33328 2.83325C3.99994 1.83325 3.33328 1.83325 3.33328 1.83325C3.13328 2.59992 3.13328 3.39992 3.33328 4.16659C2.84786 4.84384 2.61226 5.66844 2.66661 6.49992C2.66661 8.83325 4.66661 10.1666 6.66661 10.1666C6.40661 10.4933 6.21328 10.8666 6.09994 11.2666C5.98661 11.6666 5.95328 12.0866 5.99994 12.4999M5.99994 12.4999V15.1666M5.99994 12.4999C2.99328 13.8333 2.66659 11.1666 1.33325 11.1666"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Soc2Logo({ className }: { className?: string }) {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_19962_15720)" className={className}>
        <path
          d="M40.8789 6.96625C46.7951 12.8279 49.2351 21.1572 47.403 29.3413C47.3078 29.7672 47.1711 30.1834 47.0807 30.6105L41.3281 28.9886C41.5148 28.1916 41.7418 27.3923 41.8651 26.5807C43.2395 17.4911 37.5076 8.75415 28.6692 6.41218C18.7079 3.77365 8.47446 9.99653 6.34452 20.0381C5.76473 22.7718 5.8282 25.5482 6.48 28.2588C6.52883 28.4614 6.57155 28.6652 6.66431 28.8531L0.842063 30.4787C0.724886 29.7562 0.513722 29.0496 0.384339 28.3295C-2.07028 14.5682 7.52728 1.65258 21.3847 0.146588C28.7059 -0.64912 35.6706 1.80635 40.8789 6.96625ZM23.251 1.64037H22.9117L22.9153 1.97599C23.0435 2.0248 23.1192 2.0248 23.2474 1.97599L23.251 1.64037ZM28.9073 2.1859C28.6802 2.25302 28.8731 2.62036 29.033 2.58619C29.2649 2.53615 29.2881 2.07484 28.9073 2.1859ZM27.8539 2.24936C27.5561 2.20664 27.5658 2.41899 27.5829 2.65575H27.1765V2.85834C27.3071 2.85346 27.445 2.83637 27.5133 2.96574C27.4657 3.31234 27.2875 3.83101 27.3876 4.17028C27.4401 4.34846 28.1761 4.49491 28.0577 4.07631C27.3315 4.19713 27.7794 3.34895 27.7868 2.92547C27.8014 2.90594 28.1822 3.14514 28.2603 2.95964C28.3153 2.80342 28.286 2.81685 28.159 2.79244C28.0565 2.77291 27.9576 2.75339 27.86 2.71677L27.8539 2.24936ZM23.251 2.38482H22.98L23.0484 4.00919L23.3169 3.93597C23.3255 3.7529 23.2571 3.55276 23.2486 3.36725C23.2351 3.04018 23.2632 2.70945 23.251 2.3836V2.38482ZM25.0111 2.38482H23.793C23.7783 2.7961 23.9712 2.57765 24.1604 2.58863L24.6059 2.68993C24.3093 3.07436 23.8027 3.45268 23.7258 3.94207H25.0123V3.73948L24.1323 3.70531L24.9794 2.65697L25.0136 2.38604L25.0111 2.38482ZM22.5052 4.00919C22.3844 3.6748 22.4503 3.26108 22.3563 2.90594C22.2025 2.3299 21.6215 2.34455 21.2529 2.72288L21.1809 2.58375L20.949 2.58741L21.0845 4.14466L21.3188 4.14222L21.4128 4.0458C21.3615 3.71751 21.2163 3.22569 21.392 2.93035C21.5434 2.67528 21.7704 2.67528 22.0194 2.80342L22.1671 4.00919H22.5064H22.5052ZM26.6357 4.14466C26.6736 3.85908 26.6833 3.58205 26.7016 3.29647C26.7163 3.06703 26.8274 2.99137 26.6662 2.72654C26.4832 2.42266 25.8997 2.37018 25.619 2.55324C25.4774 2.64599 25.6385 2.76071 25.6202 2.85956C25.8668 2.69359 26.1499 2.66674 26.4185 2.80586L26.5002 3.13049C26.1621 3.0231 25.4579 3.02188 25.3626 3.4478C25.2296 4.04336 25.9412 4.24839 26.3623 3.94329C26.3379 4.09096 26.5088 4.14222 26.6357 4.14466ZM20.6109 4.21178C20.4876 3.86884 20.4864 2.99869 20.1373 2.82417C19.7699 2.73142 19.3561 2.77658 19.1217 3.09632L19.2841 3.25864C19.5575 3.05727 19.9322 2.80953 20.1373 3.23057C20.1983 3.35627 20.0469 3.3282 19.9859 3.34773C19.6918 3.4417 19.3073 3.49662 19.2023 3.85176C19.0131 4.49369 20.0872 4.6438 20.3082 4.07631L20.3423 4.28012L20.6133 4.21178H20.6109ZM28.6668 4.48393C28.6924 4.03116 28.9134 3.56496 28.9768 3.13171C28.989 3.04751 29.011 2.95964 28.9036 2.92791C28.7767 2.89007 28.7608 2.90106 28.7205 3.01333C28.5704 3.43682 28.5362 3.89325 28.3958 4.31918C28.3922 4.46929 28.5386 4.50712 28.6668 4.48515V4.48393ZM18.4431 3.12927C18.3137 2.98282 18.1538 3.33552 18.133 3.33796C17.8792 3.24277 17.6875 3.25864 17.4483 3.38556C16.5902 3.84077 17.1151 5.13929 18.1086 4.8586C18.3503 4.79025 18.4089 4.62794 18.5798 4.48393C18.5847 4.77195 18.7446 4.94403 18.5151 5.19665C18.1697 5.5762 17.6033 5.26255 17.5655 5.2955L17.5032 5.47368C17.4532 5.74584 18.2722 5.63234 18.4626 5.54935C19.2572 5.20519 18.7971 4.39606 18.614 3.8066C18.5749 3.6809 18.4821 3.17077 18.4455 3.12927H18.4431ZM30.7491 3.48563C30.5026 3.25986 29.9338 3.20006 29.6469 3.39898C28.8828 3.92742 29.4089 5.08559 30.3805 4.8769C30.9725 4.74998 31.1593 3.86274 30.7491 3.48563ZM16.5475 3.67114C16.4804 3.60157 16.0275 3.91522 16.0727 4.07753C15.9262 3.96159 15.9177 3.95061 15.7346 4.00919L16.2411 5.36507C16.3058 5.44561 16.5841 5.50786 16.5426 5.33578C16.462 4.99894 15.9921 4.39484 16.3095 4.07631C16.3949 3.99088 16.5499 4.02628 16.6134 3.90179L16.5487 3.67114H16.5475ZM31.9087 3.88593L31.6463 3.8066C31.6536 3.90057 31.6463 3.98966 31.6158 4.07997C31.4949 4.43267 31.2691 4.85127 31.108 5.19421L31.3424 5.36141C31.6243 4.9184 31.6133 4.12391 32.3469 4.28989L32.4946 4.41315C32.6472 4.71459 32.1748 5.32968 32.1187 5.66041L32.3908 5.7678C32.4641 5.38215 32.9023 4.76829 32.7875 4.39118C32.7106 4.13855 32.1577 3.88593 31.9185 4.07631L31.9099 3.88349L31.9087 3.88593ZM13.9562 3.95671C13.7987 3.98478 13.6327 4.08852 13.5058 4.18371C12.7905 4.71581 12.8784 5.76048 13.6132 6.23278C14.2467 6.64162 15.3525 6.21203 15.4624 5.4627C15.6015 4.51688 14.9143 3.78463 13.9562 3.95671ZM36.453 5.77024C36.077 4.1654 33.8153 4.72679 34.0985 6.33163C34.1583 6.66969 34.3804 6.94184 34.6685 7.11636C34.9565 7.29088 35.2666 7.27013 35.5742 7.26037L35.5717 7.02605L35.4753 6.93208C34.9688 7.17738 34.3719 6.65992 34.3511 6.14369C34.3304 5.62746 34.8345 5.0917 35.3374 5.0917C35.6938 5.0917 36.16 5.38215 36.1173 5.77146H36.4542L36.453 5.77024ZM12.1424 7.05168C12.2876 6.92475 11.8348 6.61477 11.7212 6.56717C10.9877 6.26329 10.3762 7.2982 10.9254 7.90474C11.4747 8.51129 12.3218 8.06828 12.417 7.32749H12.0801C12.0899 7.73877 11.7249 8.01092 11.3355 7.83152C11.2757 7.80467 11.1427 7.81321 11.1988 7.69971C11.2342 7.62893 11.9959 7.1127 12.1424 7.05168ZM36.7703 6.73559C35.6852 6.78441 35.6938 8.4881 36.8936 8.41366C37.5979 8.36972 37.8494 7.42878 37.3697 6.98699C37.272 6.89668 36.8997 6.73071 36.7703 6.73559ZM10.2516 7.5972C9.45094 7.63137 9.05668 8.50519 9.70848 9.05437C10.1333 9.41195 10.6215 9.29357 10.9181 8.83958C11.0304 8.66872 11.1537 8.31724 10.8265 8.40999C10.7033 8.44539 10.7594 8.89206 10.4201 8.95186C10.1308 9.00311 9.94772 8.94576 9.77562 8.7151C9.44972 8.27697 9.77562 7.91573 10.2455 7.86447L10.2492 7.59842L10.2516 7.5972ZM38.5524 8.13906L38.3828 7.86935L37.3355 8.99213L37.5015 9.22157C37.6138 9.04583 37.7749 8.94209 37.9043 8.81273C38.0495 8.6675 38.1179 8.47101 38.3962 8.41854C38.5622 8.38803 38.8917 8.62357 38.8917 8.781C38.8917 9.04949 38.2387 9.50104 38.0801 9.73658L38.2473 9.96724L39.026 9.18984C39.4056 8.67971 38.9699 8.19764 38.4157 8.20741L38.5512 8.14028L38.5524 8.13906ZM8.3524 8.34531C8.04725 8.19154 7.92031 8.40023 8.01796 8.67971C8.29747 8.71998 8.39878 8.62357 8.3524 8.34531ZM8.66731 8.81883C8.61361 8.83104 8.54647 8.94576 8.49155 8.98481L9.60839 10.1015C9.69017 10.01 9.82566 9.95381 9.74632 9.83055C9.64013 9.66336 9.01518 9.07878 8.82965 8.91769C8.78205 8.87619 8.74787 8.80053 8.66609 8.82005L8.66731 8.81883ZM40.3748 9.4205C40.3797 8.96162 40.0562 9.18252 39.8719 9.42538L39.6693 9.15566L39.5008 9.3253L39.7034 9.59501C39.4142 9.88913 39.0126 10.0954 38.8344 10.4871L39.1969 10.9838L39.3653 10.8154C39.2494 10.6946 39.0968 10.6263 39.1945 10.442C39.2201 10.3944 39.7742 9.85252 39.8157 9.84032C39.9866 9.79028 40.0928 10.0112 40.2124 10.1051L40.3809 9.93673L40.1123 9.60356L40.3772 9.42416L40.3748 9.4205ZM7.20504 10.5079C7.63469 10.5567 8.27428 10.9533 8.66609 10.9826C8.77839 10.9912 8.93707 10.9094 8.95904 10.8044C8.97612 10.7239 8.25963 9.39365 8.1864 9.35825C8.0741 9.30334 8.02406 9.52545 8.03016 9.58403C8.04603 9.7378 8.649 10.5567 8.55868 10.6446L7.43085 10.2455C7.32954 10.2284 7.17818 10.4005 7.20504 10.5091V10.5079ZM40.7178 10.3053C40.6018 10.2772 40.5823 10.3492 40.5151 10.4066C40.1587 10.7068 39.8011 11.0009 39.4325 11.2865L39.6619 11.4525C39.8597 11.3182 40.3467 10.8594 40.5518 10.8447C40.8142 10.8252 40.9875 11.1474 41.0888 11.1169C41.3793 10.8472 40.9692 10.6726 40.7165 10.6409V10.3053H40.7178ZM6.52761 11.4549L7.77139 12.2616L7.94838 12.0993C7.6115 11.821 7.15011 11.6587 7.01218 11.2084C6.98899 11.0131 7.35639 10.8813 7.10251 10.7117C6.83764 10.6372 6.79492 11.0888 6.79614 11.2536C6.66065 11.1608 6.52028 11.2938 6.52761 11.4561V11.4549ZM41.8529 11.8113C41.8383 11.7954 41.5844 11.6221 41.5502 11.6063C40.824 11.2621 40.0806 12.0908 40.5237 12.8352C40.9692 13.5845 42.1581 13.1427 42.0738 12.3068C42.0677 12.247 41.8895 11.8516 41.8529 11.8113ZM6.93407 12.2689C6.62892 12.1432 6.15044 12.0078 5.88801 12.2714C5.42052 12.7412 5.64267 13.5626 6.30546 13.6748C6.98899 13.7908 7.3625 13.2428 7.27217 12.607H7.0012C7.08664 13.1623 6.8413 13.5089 6.25663 13.4198L6.93407 12.2702V12.2689ZM43.3933 12.6814L41.3281 13.8604C41.2255 13.9104 41.3171 14.0459 41.361 14.0971C41.4416 14.1935 41.4233 14.1508 41.5075 14.1069C42.1813 13.7554 42.8062 13.3087 43.4934 12.978L43.5605 12.845L43.3921 12.6802L43.3933 12.6814ZM4.6308 13.4198C3.9851 13.4064 3.68483 14.5182 4.19993 14.833C4.92862 15.2785 5.16054 14.351 5.61582 14.2997C6.22734 14.2314 6.04181 15.2614 5.51329 15.2516V15.4811L5.67319 15.5811C6.21147 15.359 6.59108 14.4693 6.05157 14.0654C5.74642 13.8372 5.3717 13.9824 5.10927 14.2021C5.04702 14.2545 5.02871 14.3436 4.96646 14.3986C4.86393 14.4901 4.65887 14.6487 4.53437 14.6402C4.00219 14.6024 4.19749 13.6822 4.70037 13.6895L4.6308 13.4198ZM42.6817 17.0066C42.8306 17.0407 42.8331 16.9248 42.8978 16.8504C43.1114 16.6051 43.2566 16.3109 43.4604 16.0595C43.9182 16.7064 44.8324 16.3244 44.642 15.5567C44.6115 15.4322 44.3722 14.7781 44.3088 14.7342C44.2392 14.6853 44.1708 14.7012 44.1 14.7342L42.1385 15.5177L42.2069 15.8557L43.1199 15.4457C43.2566 15.4152 43.3616 15.7276 43.3262 15.7886C43.2151 15.9863 42.6561 16.555 42.6243 16.7112C42.6097 16.7845 42.7086 16.9053 42.6805 17.0054L42.6817 17.0066ZM5.30945 16.804L2.84506 17.0029L2.73155 17.3044L4.59906 18.969C5.05679 18.5162 4.24997 18.4711 4.30368 18.1379C4.3525 17.8426 4.58564 17.4606 4.63812 17.1469C4.95548 17.1213 5.40588 17.2409 5.30945 16.8028V16.804ZM43.6289 17.4813L44.0036 18.6322C45.2584 18.31 44.4564 16.5868 43.4019 17.2189C42.7818 17.5899 42.9441 18.3161 43.4617 18.6993C43.5825 18.7347 43.6704 18.5406 43.6264 18.4332C43.1748 18.2917 43.1114 17.585 43.6301 17.4813H43.6289ZM3.41264 19.9856C3.53226 19.4694 3.6653 18.6822 2.95614 18.576C2.19082 18.4613 2.21401 19.4987 2.059 19.9856L4.32199 20.4616L4.4294 20.1211L3.41386 19.9856H3.41264ZM44.9154 18.9714L42.6829 19.3791V19.6475L43.6289 19.5121C43.1431 20.3554 44.1501 21.1316 44.8824 20.5287C45.2779 20.2028 45.1888 19.556 44.7799 19.2753L44.9837 19.2411L44.9142 18.9714H44.9154ZM2.39344 21.0632L2.22866 20.7313C1.00806 21.8016 2.49963 23.4772 3.77638 22.6156C4.37935 22.2092 4.34762 21.4489 4.01806 20.8704C3.51273 20.8741 3.88135 21.1901 3.9497 21.4476C4.26096 22.6107 2.49231 22.9036 2.12369 21.9187C2.01506 21.6271 2.0651 21.1645 2.39344 21.0644V21.0632ZM44.4918 21.1474C43.4153 21.311 43.6582 22.9841 44.7445 22.8267C45.5379 22.712 45.7051 21.5075 44.9325 21.2207C44.8141 21.1767 44.6164 21.1279 44.4918 21.1474ZM45.4573 23.3027H43.8999C43.873 23.7994 44.0646 23.5834 44.3381 23.5712C44.5797 23.5602 45.0094 23.5565 45.151 23.7774C45.2926 23.9983 45.1278 24.268 45.5245 24.1814C45.5989 23.9483 45.3682 23.7652 45.3206 23.6053C45.306 23.5541 45.4488 23.5944 45.4598 23.5346L45.4561 23.3015L45.4573 23.3027ZM4.09007 23.4381H1.95769C1.94304 23.4381 1.893 23.3588 1.82831 23.3722L1.75263 23.4369L1.72089 23.7091H4.09007V23.4381ZM4.09007 24.1155L1.79535 25.2053L1.79169 25.5324L4.22434 26.3488L4.145 26.023C4.02538 25.9803 3.70681 25.9375 3.62869 25.8619C3.47123 25.7093 3.57376 24.9124 3.55423 24.6634C3.82642 24.5707 4.15476 24.4706 4.08885 24.1155H4.09007ZM44.205 24.9954C44.4381 24.9307 44.9191 25.043 45.1864 24.9954V25.4689H45.4573V25.0625L45.8589 25.0576L45.9309 24.8257L45.4573 24.7928C45.4573 24.6415 45.5025 24.4877 45.356 24.3864L45.1546 24.7818C44.9606 24.7135 44.0927 24.6708 43.9646 24.755C43.8364 24.8392 43.7827 25.2029 43.8632 25.3359L44.1025 25.4006C44.0402 25.2895 44.0781 25.0296 44.2038 24.9942L44.205 24.9954ZM44.1708 25.6715C43.9963 25.4848 43.7448 26.0986 43.7253 26.2121C43.6496 26.632 44.0427 27.0945 44.4687 26.815C44.7238 26.6466 44.6078 26.1584 44.9447 26.0803L45.1241 26.3818L44.9227 26.6649L44.985 26.9578C45.6087 26.7857 45.3902 25.5043 44.7128 25.8411C44.4528 25.9314 44.4369 26.8211 44.1 26.5892C43.8169 26.394 44.0292 26.0938 44.1757 25.9083C44.2306 25.8387 44.194 25.6959 44.1721 25.6727L44.1708 25.6715Z"
          fill="currentColor"
        />
        <path
          d="M6.79881 29.1923C6.89524 29.6182 7.05758 30.0868 7.22114 30.4969C9.3816 35.9448 14.1847 40.1198 19.919 41.4257C28.8721 43.465 37.6482 38.6297 40.9072 30.1576C40.9694 29.9941 41.1171 29.3668 41.2343 29.3314L46.882 30.9838L46.9504 31.1181C46.1155 33.6663 44.9193 36.1035 43.3215 38.2575C37.5029 46.0986 27.5514 49.6781 18.0234 47.2482C9.92843 45.1833 3.40433 38.9019 0.98877 30.9167C1.03881 30.824 1.14012 30.7983 1.23167 30.7666C2.97346 30.1564 4.89102 29.8171 6.6438 29.2045L6.80003 29.1923H6.79881ZM8.49178 36.5025L8.82867 36.2658L7.94984 34.9453L5.99078 36.3414C6.0274 36.4134 6.10307 36.6648 6.21659 36.6331C6.45216 36.566 6.8098 36.1108 7.02585 36.1706C7.19673 36.2182 7.50798 37.0188 7.70328 36.9712C7.7399 36.9065 7.95838 36.8357 7.94984 36.8076C7.88881 36.5953 7.33954 36.0973 7.33832 35.8618L7.8412 35.5604L8.493 36.5025H8.49178ZM40.9939 36.8455C40.9585 37.164 41.0585 37.2592 41.3246 37.0737C41.6408 36.854 41.8056 36.4525 41.7238 36.0729C41.6786 35.9179 41.3857 35.7947 41.2282 35.8228C40.9633 35.8594 40.6863 36.3536 40.4824 36.2987C40.4165 36.2804 40.3469 36.1498 40.3884 36.0705L40.7827 35.7154C40.7986 35.6543 40.7241 35.4127 40.6863 35.4225C40.1992 35.5518 39.7598 36.3024 40.2749 36.6417C40.7412 36.948 40.956 36.1901 41.3954 36.2316C41.4992 36.5098 41.2929 36.8088 40.9939 36.8455ZM39.9734 36.638C39.6878 36.505 39.6585 36.6685 39.4583 36.8381C39.3509 36.8613 39.1837 36.5733 39.0263 36.6685C38.7724 36.8211 38.9079 37.081 39.1569 37.1164C39.1666 37.5655 38.5612 37.596 38.6869 38.1269L38.5185 37.9914L38.2792 38.2282C38.2487 38.4466 38.4037 38.4308 38.5185 38.5333C38.8395 38.8189 39.1251 39.1484 39.4669 39.4132L39.7025 39.1093C39.4535 38.7505 38.8175 38.5394 38.9689 38.0366C39.0006 37.9316 39.1495 37.8767 39.1923 37.7888C39.213 37.7461 39.1605 37.6778 39.1727 37.6656C39.1861 37.6497 39.5035 37.452 39.5243 37.4569C40.0479 37.856 40.6094 38.504 40.9914 37.5521C40.9939 37.4178 40.8706 37.3629 40.7534 37.3812C40.7046 37.3898 40.7095 37.4972 40.6521 37.5521C40.3823 37.8108 40.0345 37.2311 39.7757 37.1762C39.7073 36.9333 40.032 36.8931 39.9734 36.6404V36.638ZM8.20372 37.1933C7.48601 37.2628 7.16255 38.0146 7.58 38.5992C8.20738 39.4779 9.57079 38.792 9.06058 37.7278C8.92876 37.452 8.51375 37.1628 8.20372 37.1933ZM9.91256 38.9397C10.031 38.7725 9.88937 38.4796 9.68431 38.5406L8.62727 39.6512L8.9251 39.8855C9.35841 39.5011 9.73923 38.7969 10.2861 39.4816C10.7548 39.152 10.3117 38.947 9.91378 38.9409L9.91256 38.9397ZM37.8569 38.8848C37.2527 38.9787 36.7474 39.7488 37.1624 40.2956C37.8533 41.2072 39.1239 40.2663 38.7394 39.3961C38.5868 39.0495 38.2414 38.825 37.8569 38.8848ZM10.861 39.8196C10.9952 39.6195 10.828 39.5548 10.6925 39.4144L9.64403 40.6653L10.0102 40.8997C10.2824 40.619 10.5827 39.8818 11.066 40.1223C11.5237 40.3505 10.8024 40.9753 10.6571 41.2048C10.5216 41.4171 10.7047 41.6331 10.8903 41.5758C11.0965 41.5123 11.4566 40.4371 11.9424 40.8033C12.3464 41.1084 11.6226 41.7454 11.4041 42.0188C11.525 42.1347 11.6116 42.3019 11.8045 42.2507C11.918 41.9236 12.3611 41.6417 12.4551 41.3109C12.6223 40.7276 12.228 40.4286 11.6775 40.4921C11.6702 40.0344 11.3077 39.7549 10.861 39.8184V39.8196ZM36.9085 40.4481C36.4862 40.0246 35.5598 40.2809 35.5732 40.9033C35.3815 40.8338 35.2363 40.8301 35.102 41.0107L36.4923 42.9329L36.7803 42.6986L36.2506 41.9187C36.8096 42.0127 37.3272 41.4513 37.1673 40.8997C37.1453 40.8252 36.9598 40.4994 36.9085 40.4481ZM12.8408 42.6473C12.7443 42.5411 12.7004 42.28 12.8579 42.1909L13.9393 42.7986C14.325 42.2397 14.1151 41.5367 13.3961 41.4489C12.3696 41.3232 12.001 42.7205 13.0275 43.105C13.2204 43.177 13.4743 43.2551 13.639 43.1013L13.5048 42.8291C13.307 42.9121 12.9763 42.7962 12.842 42.6485L12.8408 42.6473ZM34.2195 42.596L35.2326 42.0151C35.1936 41.6844 34.781 41.4269 34.4576 41.4391C34.0084 41.4574 33.5275 42.0334 33.6227 42.4801C33.8326 43.4589 35.2412 43.3222 35.4389 42.3922L35.0398 42.3983C34.991 42.8243 34.3367 43.1172 34.2208 42.5948L34.2195 42.596ZM33.8802 43.5431L32.8647 42.8999C33.1259 42.6961 33.1723 42.5521 33.1369 42.2202C33.0368 41.2682 31.6966 41.8992 31.2413 42.2287L32.2275 44.3498L32.5913 44.1862L32.1921 43.3637C32.1714 43.238 32.3801 43.1538 32.4802 43.1477L33.3798 43.8055C33.5494 43.7554 33.8009 43.72 33.879 43.5431H33.8802ZM16.6832 41.9858C16.527 42.0029 16.4074 41.9151 16.2768 41.8504L15.3284 44.2875L15.7336 44.3547L16.6832 41.9858ZM14.9915 42.5277L15.0317 42.3239C14.9121 42.2458 14.8023 42.1274 14.6863 42.2568C14.6082 42.3446 14.1285 43.3173 14.0736 43.4723C14.0492 43.5406 14.0284 43.6041 14.0455 43.6761L14.3836 43.7835C14.7303 43.2709 14.6192 42.6107 15.4236 42.8767C15.4944 42.8999 15.4773 42.9744 15.5676 42.867C15.6042 42.8243 15.6774 42.6839 15.6665 42.6351C15.4736 42.3812 15.2551 42.485 14.9927 42.5277H14.9915ZM30.0719 43.0854C30.0573 43.0696 29.8022 42.8963 29.7692 42.8804C29.4787 42.7437 29.1357 42.7889 28.8721 42.9695C28.3741 43.3112 28.5926 44.4596 28.9063 44.8941C29.1248 45.1955 29.3506 45.27 29.718 45.237C30.5809 45.1601 30.5455 44.2448 30.3258 43.6102C30.299 43.5333 30.1061 43.1233 30.0719 43.0854ZM16.9481 43.1428L16.5477 43.0012L16.6722 44.7842C16.4989 45.0503 16.2267 45.2614 15.9728 44.9649C15.4919 45.3957 16.3353 45.6105 16.6527 45.3725L18.1736 43.6432C18.2358 43.5052 17.8904 43.4393 17.7659 43.5065C17.6939 43.5455 17.3228 44.0691 17.2264 44.1862C17.1751 44.2473 17.1007 44.3327 17.0238 44.3559L16.9505 43.1428H16.9481ZM21.0163 43.476C20.6196 43.266 20.1546 43.0647 19.7103 43.2868C19.3795 43.4515 19.2367 43.9007 19.4283 44.2167C19.6493 44.5816 20.6355 44.661 20.2278 45.2395C19.8214 45.4152 19.6151 45.2724 19.3575 44.9722L19.0524 45.2028C19.3221 45.7569 20.1168 45.7654 20.5952 45.4921C20.7075 45.2651 20.8516 44.9148 20.7319 44.6756C20.5366 44.2826 19.7677 44.2277 19.8092 43.7945C19.8348 43.5236 20.1827 43.4991 20.3889 43.5956C20.5037 43.6493 20.6001 43.8226 20.7002 43.8067C20.8369 43.7383 21.031 43.6554 21.0163 43.476ZM28.1251 43.205L26.4321 43.476L26.5005 43.814L27.7186 43.6114L27.0412 45.7777L27.5526 45.6458C27.5941 45.287 28.2984 43.393 28.1251 43.205ZM22.5702 43.5467L22.1332 43.609L20.9504 45.8436L21.4167 45.8362C21.4777 45.6593 21.5583 45.381 21.7572 45.3334C21.7914 45.3249 22.3151 45.3578 22.4066 45.3664C22.5299 45.3786 22.6458 45.425 22.7654 45.4481L22.9168 45.9741L23.3867 46.0461C23.3989 45.9485 23.3843 45.8655 23.3562 45.7728C23.1267 45.0259 22.7667 44.301 22.5714 43.5455L22.5702 43.5467ZM25.214 43.6785C24.6427 43.3795 23.5955 43.515 23.6528 44.3229C23.7053 45.0466 24.6879 44.866 24.8429 45.1662C25.0187 45.5079 24.6403 45.7691 24.3132 45.6983C24.0617 45.6434 23.9299 45.3273 23.6894 45.7081C23.6296 45.8021 23.6528 45.813 23.7261 45.8789C23.9104 46.0449 24.3962 46.0767 24.6354 46.0449C25.048 45.9912 25.3775 45.63 25.3519 45.2053C25.347 45.1345 25.1786 44.8233 25.131 44.7794C24.9882 44.6463 24.1484 44.5072 24.1289 44.3839C24.0349 43.775 24.644 43.7591 25.0114 44.0862L25.2152 43.6798L25.214 43.6785Z"
          fill="currentColor"
        />
        <path
          d="M18.9694 25.9606C21.0078 25.7495 22.7179 26.9309 22.9083 29.0275C23.1463 31.6392 20.9211 33.3539 18.4275 32.7632C14.8706 31.9199 15.1294 26.3573 18.9694 25.9606ZM21.0652 31.0693C21.3056 30.8142 21.5937 30.0551 21.6266 29.7024C21.7365 28.5491 21.0676 27.2408 19.8263 27.0993C16.4464 26.7148 16.4367 31.5745 19.2184 31.7686C19.8629 31.8137 20.6197 31.5416 21.0652 31.0705V31.0693Z"
          fill="currentColor"
        />
        <path
          d="M14.6325 27.2775C14.5617 27.3544 14.4079 27.4191 14.3468 27.568C14.2541 27.5912 14.1076 27.3788 13.999 27.3068C13.5876 27.0395 12.826 26.9785 12.4207 27.2653C11.9166 27.6229 12.0216 28.2075 12.5318 28.5028C13.1629 28.8677 13.9636 28.8848 14.58 29.3656C15.4527 30.0479 15.3758 31.6234 14.5507 32.3056C13.6487 33.0513 11.9178 33.0489 11.0012 32.3349C10.917 32.269 10.541 31.9407 10.6631 31.837L11.5041 31.0877C11.9618 31.6173 12.7356 31.9908 13.4143 31.6429C13.9904 31.3476 14.132 30.6434 13.5657 30.2431C12.959 29.8148 12.0314 29.8477 11.4003 29.2936C10.6008 28.5919 10.6423 27.1714 11.4735 26.5209C12.3975 25.7984 13.7646 25.7703 14.7655 26.3341C15.3868 26.6844 15.0902 26.7039 14.7496 27.0896C14.6959 27.1506 14.6752 27.2275 14.6312 27.2751L14.6325 27.2775Z"
          fill="currentColor"
        />
        <path
          d="M25.436 31.1364C25.7167 31.4281 26.3404 31.7198 26.742 31.76C27.2803 31.8125 27.6684 31.6771 28.0908 31.3585C28.1909 31.2829 28.3093 31.0961 28.3947 31.051C28.6596 30.9131 29.1893 31.5806 29.4786 31.6295C28.6413 33.0671 26.4259 33.1647 25.0991 32.3861C22.963 31.1315 22.9935 27.6692 25.1235 26.4281C26.0499 25.8886 27.3682 25.7581 28.3446 26.2291C28.5424 26.3243 29.0868 26.6905 29.2101 26.8528C29.2613 26.9199 29.2967 26.9553 29.2699 27.0505C29.2223 27.2165 28.5473 27.5057 28.4228 27.6997C28.3288 27.7217 28.1274 27.4508 28.0126 27.3739C27.1558 26.7979 25.851 27.1005 25.2517 27.9096C24.6011 28.7883 24.6743 30.3468 25.4347 31.1352L25.436 31.1364Z"
          fill="currentColor"
        />
        <path
          d="M34.7601 31.765H37.4686V32.8475H32.7974L32.8303 32.0347C33.3064 31.6075 33.758 31.1584 34.2169 30.713C34.8309 30.1174 35.9013 29.1887 35.9807 28.2795C36.093 26.9895 34.8748 26.7601 33.9008 27.214C33.8129 27.2555 33.3149 27.6217 33.2722 27.5667L32.9365 26.5562C33.1867 26.4781 33.4284 26.2609 33.6603 26.1608C35.4192 25.403 37.5797 26.1547 37.3294 28.3405C37.1744 29.6915 35.6487 30.857 34.7613 31.7637L34.7601 31.765Z"
          fill="currentColor"
        />
        <path
          d="M21.5764 16.1462C21.1748 16.5318 20.9161 17.3055 20.9454 17.8572C21.0552 19.8904 23.7247 20.6507 25.1271 19.3583C25.193 19.2973 25.2968 19.008 25.4433 19.0422L26.0255 19.4791C25.7386 19.8928 25.2712 20.2284 24.8073 20.4274C22.9056 21.2377 20.3692 20.2907 20.141 18.0537C19.8065 14.7866 24.1738 13.5589 26.0255 15.9594C25.8998 16.0741 25.5421 16.4378 25.392 16.3939C25.3053 16.3683 25.0563 16.0558 24.9379 15.9643C23.9627 15.2101 22.4626 15.2955 21.5764 16.1474V16.1462Z"
          fill="currentColor"
        />
        <path
          d="M35.9795 20.5945L35.1641 20.564L34.2487 18.7639L31.7892 18.7749L30.8945 20.5884L30.0217 20.5957L33.0342 14.5718L35.9795 20.5957V20.5945ZM33.88 18.0219L33.0342 16.3292L32.1883 18.0219H33.8813H33.88Z"
          fill="currentColor"
        />
        <path
          d="M17.9026 20.5945L17.0872 20.564L16.1437 18.7993L13.7464 18.7749L12.8298 20.5652L11.946 20.5945L14.9255 14.5022L17.9038 20.5945H17.9026ZM15.8031 18.0219L14.9573 16.3975L14.8022 16.5806L14.1102 18.0219H15.8031Z"
          fill="currentColor"
        />
        <path
          d="M27.8552 18.0218V20.5944H27.0422V14.8402H29.5139C29.5359 14.8402 29.874 14.9391 29.9351 14.961C30.123 15.0294 30.4318 15.2015 30.5637 15.3479C31.2203 16.0777 31.0665 17.2786 30.1804 17.7399C29.7129 17.984 29.4554 17.9169 28.9744 17.9547C28.9085 17.9596 28.8524 18.0206 28.8377 18.0206H27.8564L27.8552 18.0218ZM27.8552 17.2774H29.1758C29.3736 17.17 29.5908 17.2127 29.7874 17.076C30.2695 16.7416 30.2841 16.035 29.7764 15.7287C29.7324 15.703 29.4651 15.5847 29.4468 15.5847H27.8552V17.2774Z"
          fill="currentColor"
        />
        <path
          d="M19.1889 14.8403V20.5945H18.376V14.8403C18.6384 14.7768 18.9143 14.8757 19.1889 14.8403Z"
          fill="currentColor"
        />
        <path d="M35.7758 23.3026H12.1475V23.4381H35.7758V23.3026Z" fill="currentColor" />
        <path
          d="M14.9742 5.82138C14.9595 5.83725 14.7044 6.01177 14.6715 6.02641C14.1686 6.26195 13.6474 6.02763 13.4191 5.54679C13.0932 4.85848 13.5827 4.14332 14.3492 4.21044C14.8497 4.25438 15.2891 4.90485 15.1805 5.38448C15.1695 5.43329 14.9998 5.79209 14.973 5.82138H14.9742Z"
          fill="currentColor"
        />
        <path
          d="M17.6779 3.549C18.309 3.40865 18.5885 4.03838 18.2394 4.51556C18.0783 4.63639 17.8696 4.64127 17.6755 4.6071C17.2886 4.36057 17.2044 3.99933 17.4973 3.63809C17.5522 3.60148 17.6133 3.56364 17.6779 3.549Z"
          fill="currentColor"
        />
        <path
          d="M44.1708 15.0441C44.2465 15.3394 44.4589 15.5481 44.3661 15.8825C43.8999 16.3633 43.5862 15.8227 43.4971 15.3553L44.1708 15.0453V15.0441Z"
          fill="currentColor"
        />
        <path
          d="M4.2929 17.142L4.09028 18.0219C3.98775 18.0475 3.97921 17.9987 3.92062 17.9548C3.69237 17.7815 3.43848 17.5008 3.21023 17.3116C3.20535 17.153 3.85715 17.2225 3.99141 17.2127C4.10249 17.2054 4.18671 17.1444 4.2929 17.142Z"
          fill="currentColor"
        />
        <path
          d="M3.27725 24.8599C3.24307 25.1625 3.31753 25.4432 3.34438 25.7398L2.19336 25.4017L2.3618 25.265L3.27725 24.8599Z"
          fill="currentColor"
        />
        <path
          d="M44.697 19.4608C44.8594 19.606 44.9363 19.9355 44.8338 20.1393C44.5359 20.73 43.5582 20.431 43.7962 19.7098C43.9049 19.3802 44.4615 19.2497 44.697 19.4596V19.4608Z"
          fill="currentColor"
        />
        <path
          d="M3.1369 19.8452C3.00141 19.8586 2.42407 19.8 2.39966 19.6768C2.48876 19.3595 2.49242 18.8164 2.95869 18.9128C3.39445 19.0031 3.2138 19.534 3.1369 19.8452Z"
          fill="currentColor"
        />
        <path
          d="M10.9965 7.52997C10.9281 7.12968 11.0758 6.8319 11.5006 6.7843L11.8082 6.95516L10.9965 7.52997Z"
          fill="currentColor"
        />
        <path
          d="M43.8328 17.3458C44.393 17.3946 44.6005 17.9414 44.1367 18.2929L43.8328 17.3458Z"
          fill="currentColor"
        />
        <path
          d="M6.52768 12.4043L6.44712 12.6289L6.01991 13.2171C5.61101 12.8485 6.05775 12.2481 6.52768 12.4055V12.4043Z"
          fill="currentColor"
        />
        <path
          d="M26.4332 3.33295C26.4625 3.55384 26.2574 3.82721 26.0475 3.86505C25.8376 3.90288 25.4799 3.63439 25.6862 3.43058C25.8376 3.24874 26.2086 3.36102 26.4344 3.33295H26.4332Z"
          fill="currentColor"
        />
        <path
          d="M41.3075 11.81C41.5395 11.7941 41.8409 12.2091 41.7921 12.4239C41.6676 12.9718 41.0305 13.1744 40.7278 12.6313C40.4861 12.1981 40.8803 11.8393 41.3075 11.81Z"
          fill="currentColor"
        />
        <path
          d="M20.2033 3.53564C20.3254 4.08849 19.8396 4.38139 19.4612 3.97011C19.5625 3.6528 19.9201 3.59178 20.2033 3.53564Z"
          fill="currentColor"
        />
        <path
          d="M44.6251 21.4256C45.3098 21.3975 45.3904 22.5264 44.6116 22.5264C43.8329 22.5264 43.8402 21.4573 44.6251 21.4256Z"
          fill="currentColor"
        />
        <path
          d="M36.756 7.01496C37.1173 6.99543 37.3968 7.33837 37.3333 7.69961C37.2198 8.34642 36.1322 8.30371 36.2519 7.49824C36.2848 7.27979 36.5448 7.02716 36.7547 7.01496H36.756Z"
          fill="currentColor"
        />
        <path
          d="M29.9303 3.54657C30.3697 3.41477 30.8043 3.76869 30.6688 4.21536C30.4442 4.95493 29.3615 4.74502 29.6264 3.85168C29.6447 3.78822 29.8681 3.5661 29.9303 3.54779V3.54657Z"
          fill="currentColor"
        />
        <path
          d="M32.6449 42.6474C32.5778 42.7206 32.0249 42.9769 31.9858 42.9342L31.7856 42.3667C32.0664 42.136 32.5082 41.8761 32.7218 42.302C32.7487 42.3972 32.7109 42.5742 32.6449 42.6474Z"
          fill="currentColor"
        />
        <path
          d="M22.3698 44.085L22.6395 44.999C22.5871 45.0613 22.5895 45.0784 22.5041 45.0686C22.3307 45.0491 22.0549 45.0576 21.9353 45.0259C21.9011 45.0174 21.7985 44.938 21.8596 44.8953C21.9987 44.6659 22.0866 44.4023 22.2209 44.1716C22.2624 44.1008 22.2087 44.0532 22.3698 44.0837V44.085Z"
          fill="currentColor"
        />
        <path
          d="M29.2956 44.7428C29.0002 44.4463 28.7134 43.1844 29.3078 43.1636C29.7826 43.1465 30.0817 43.9227 30.0817 44.323C30.0817 44.777 29.652 45.1016 29.2956 44.744V44.7428Z"
          fill="currentColor"
        />
        <path
          d="M36.1615 40.6434C36.6986 40.5263 37.033 41.2195 36.5863 41.5441C35.8905 42.0506 35.3803 40.8131 36.1615 40.6434Z"
          fill="currentColor"
        />
        <path
          d="M7.96556 38.5175L7.74707 38.094C7.83251 37.7157 8.12545 37.4484 8.51605 37.6632C8.87368 37.8597 8.89077 38.2734 8.58562 38.526C8.39032 38.642 8.15963 38.6298 7.96556 38.5175Z"
          fill="currentColor"
        />
        <path
          d="M37.786 39.2912C38.4854 39.1325 38.6392 40.1503 38.0313 40.2821C37.3771 40.4237 37.1244 39.4413 37.786 39.2912Z"
          fill="currentColor"
        />
        <path
          d="M34.2633 41.7943C34.4623 41.7345 34.6417 41.7845 34.7601 41.9529L34.0497 42.3923C33.8056 42.2568 34.1059 41.8419 34.2633 41.7955V41.7943Z"
          fill="currentColor"
        />
        <path
          d="M13.7719 42.324C13.7121 42.385 13.1629 42.0823 13.0957 42.0189C13.0115 41.9395 13.0188 41.8907 13.0274 41.7821C13.4277 41.5978 13.8452 41.8785 13.7719 42.3228V42.324Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_19962_15720">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SlackLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 3.5C16 2.67157 15.3284 2 14.5 2C13.6716 2 13 2.67157 13 3.5V8.5C13 9.32843 13.6716 10 14.5 10C15.3284 10 16 9.32843 16 8.5V3.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 8.5V10H20.5C20.7967 10 21.0867 9.91203 21.3334 9.74721C21.58 9.58238 21.7723 9.34812 21.8858 9.07403C21.9993 8.79994 22.0291 8.49834 21.9712 8.20737C21.9133 7.91639 21.7704 7.64912 21.5607 7.43934C21.3509 7.22956 21.0836 7.0867 20.7926 7.02882C20.5017 6.97095 20.2001 7.00065 19.926 7.11418C19.6519 7.22771 19.4176 7.41997 19.2528 7.66665C19.088 7.91332 19 8.20333 19 8.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 15.5C11 14.6716 10.3284 14 9.5 14C8.67157 14 8 14.6716 8 15.5V20.5C8 21.3284 8.67157 22 9.5 22C10.3284 22 11 21.3284 11 20.5V15.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 15.5V14H3.5C3.20333 14 2.91332 14.088 2.66665 14.2528C2.41997 14.4176 2.22771 14.6519 2.11418 14.926C2.00065 15.2001 1.97094 15.5017 2.02882 15.7926C2.0867 16.0836 2.22956 16.3509 2.43934 16.5607C2.64912 16.7704 2.91639 16.9133 3.20737 16.9712C3.49834 17.0291 3.79994 16.9993 4.07403 16.8858C4.34811 16.7723 4.58238 16.58 4.7472 16.3334C4.91203 16.0867 5 15.7967 5 15.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 13H15.5C14.6716 13 14 13.6716 14 14.5C14 15.3284 14.6716 16 15.5 16H20.5C21.3284 16 22 15.3284 22 14.5C22 13.6716 21.3284 13 20.5 13Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 19H14V20.5C14 20.7967 14.088 21.0867 14.2528 21.3334C14.4176 21.58 14.6519 21.7723 14.926 21.8858C15.2001 21.9993 15.5017 22.0291 15.7926 21.9712C16.0836 21.9133 16.3509 21.7704 16.5607 21.5607C16.7704 21.3509 16.9133 21.0836 16.9712 20.7926C17.0291 20.5017 16.9993 20.2001 16.8858 19.926C16.7723 19.6519 16.58 19.4176 16.3334 19.2528C16.0867 19.088 15.7967 19 15.5 19Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 8H3.5C2.67157 8 2 8.67157 2 9.5C2 10.3284 2.67157 11 3.5 11H8.5C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 5H10V3.5C10 3.20333 9.91203 2.91332 9.74721 2.66665C9.58238 2.41997 9.34812 2.22771 9.07403 2.11418C8.79994 2.00065 8.49834 1.97094 8.20737 2.02882C7.91639 2.0867 7.64912 2.22956 7.43934 2.43934C7.22956 2.64912 7.0867 2.91639 7.02882 3.20737C6.97095 3.49834 7.00065 3.79994 7.11418 4.07403C7.22771 4.34811 7.41997 4.58238 7.66665 4.7472C7.91332 4.91203 8.20333 5 8.5 5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Slack's four-color mark, as on Slack's own "Add to Slack" button. */
export function SlackColorLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 122.8 122.8" aria-hidden {...props}>
      <path
        fill="#e01e5a"
        d="M25.8 77.6c0 7.1-5.8 12.9-12.9 12.9S0 84.7 0 77.6s5.8-12.9 12.9-12.9h12.9v12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V77.6z"
      />
      <path
        fill="#36c5f0"
        d="M45.2 25.8c-7.1 0-12.9-5.8-12.9-12.9S38.1 0 45.2 0s12.9 5.8 12.9 12.9v12.9H45.2zm0 6.5c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H12.9C5.8 58.1 0 52.3 0 45.2s5.8-12.9 12.9-12.9h32.3z"
      />
      <path
        fill="#2eb67d"
        d="M97 45.2c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9-5.8 12.9-12.9 12.9H97V45.2zm-6.5 0c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V12.9C64.7 5.8 70.5 0 77.6 0s12.9 5.8 12.9 12.9v32.3z"
      />
      <path
        fill="#ecb22e"
        d="M77.6 97c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9-12.9-5.8-12.9-12.9V97h12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H77.6z"
      />
    </svg>
  );
}
